import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import {alpha, useTheme} from "@mui/material/styles";
import {
    CloseIcon, CloseSidebarIcon,
    Logo,
    LogoIcon,
    NewLogoIcon,
    NewLogoIconWithText,
    NewProjectIcon, OpenSidebarIcon
} from "./HomeIcons";
import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {AuthContext} from "../../context/AuthContext";
import {
    AdaptRecordingMode,
    formatToReadableLargeTitle,
    GetLibrettoTrialPlanDetails,
    GridVideoLayout,
    IMAGE_UPLOAD, LibrettoProjectTypes,
    LibrettoPlan,
    LibrettoStudioNameStyle,
    LibrettoStudioTheme,
    LibrettoWorkflowTypes,
    normalizeTimestampToMillis,
    RefreshTokenAndRetry
} from "../../utils/utils";
import {collection, doc, getDoc, getDocs, onSnapshot, query, updateDoc, where} from "firebase/firestore";
import {db} from "../../Firebase";
import {
    AssetDeleted, AssetId, AssetProjectId, AssetType,
    CompositionDeleted,
    CompositionProjectId,
    kAssetsCollectionName, kLibrettoUserCollectionName,
    kCompositionsCollectionName,
    kProjectsCollectionName, kRoomStateCollectionName, kTracksCollectionName, LibrettoUserId,
    ProjectDeleted, ProjectName, ProjectNameSource,
    RoomName, RoomUserId,
    WorkspaceId
} from "../../utils/CollectionConstants";
import {
    CameraIcon,
    ChangeViewButton, EditButton, MobileLogoutButton, NewProjectButton, PlanRecordingButton,
    RecordingStudioButton,
    ShareButton,
    SortButton,
    ThreeDotsButton,
    UploadButton, V2RecordButton, ViewAllProjectsButton
} from "./HomeButtons";
import {Button, Card, ClickAwayListener, DialogContent, Typography} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import Drawer from "@mui/material/Drawer";
import {CLIENT_URL, FetchContext} from "../../context/FetchContext";
import NewEditableTitle, {ReadOnlyTitle} from "./NewEditableTitle";
import {
    GridProjects,
    ListProjects, ListViewProject,
    ListViewRecording,
    NewGridRecordings,
    RecordingsListView
} from "../NewHome/NewAssetAndProjectCards";
import {useConfirmDialog} from "./DeleteConfirmation";
import TextField from "@mui/material/TextField";
import OfflineBanner, {useIsOffline} from "../../components/OfflineBanner";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import UploadContentCard from "./UploadContentCard";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import Brightness4OutlinedIcon from "@mui/icons-material/Brightness4Outlined";
import CheckIcon from "@mui/icons-material/Check";
import IconButton from "@mui/material/IconButton";
import NewShareProjectCard from "./NewShareProjectCard";
import mixpanel from "mixpanel-browser";
import {loadStripe} from "@stripe/stripe-js";
import {
    DeleteOutlined,
    Laptop,
    RadioButtonCheckedOutlined,
    TodayOutlined,
    VideoCall
} from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import SignInUserIntercomComponent, {UnauthenticatedUserIntercomComponent} from "../../components/IntercomComponent";
import {HiLightningBolt} from "react-icons/hi";
import {
    HomeSidebarButton,
    NewSidebarThumbnailCard,
    RedesignedSidebarThumbnailCard,
    SidebarProjectThumbnail
} from "./ProjectThumbnail";
import {InviteIcon} from "../NewStudio/SettingsIcon";
import CreateSession from "./CreateSession";
import {NewInviteParticipantCard} from "../NewStudio/NewInviteParticipantCard";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import SelectableCard from "./SelectableCard";
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import HeadphonesOutlinedIcon from '@mui/icons-material/HeadphonesOutlined';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import ClosedCaptionOffOutlinedIcon from '@mui/icons-material/ClosedCaptionOffOutlined';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import SidebarNavButton, {SidebarSubdirButton} from "./SidebarNavButton";
import ContentCutOutlinedIcon from '@mui/icons-material/ContentCutOutlined';
import GraphicEqOutlinedIcon from '@mui/icons-material/GraphicEqOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import CropPortraitIcon from '@mui/icons-material/CropPortrait';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import {RecordSomethingMenu} from "./ProjectContextMenu";
import AgenticUploadContentCard from "./AgenticUploadContentCard";
import EditForClarityWorkflow from "./EditForClarityWorkflow";
import EditMultiSpeakerWorkflow from "./EditMultiSpeakerWorkflow";
import UploadAndEditWorkflow from "./UploadAndEditWorkflow";
import TranslateIcon from '@mui/icons-material/Translate';
import {useAssetStore} from "../../storage/AssetStore";
import {LegacyProjectsView} from "./LegacyProjects";
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import {trackSessionEvent} from "../../analytics/sessionEvents";
import WorkspaceSettingsModal from "./WorkspaceSettingsModal";
import {useThemeMode} from "../../components/Page";
import FirstExportActivationModal from "./FirstExportActivationModal";
import InitialOnboardingModal from "./InitialOnboardingModal";
import {
    getInitialOnboardingFirstThingLabel,
    getInitialOnboardingRoleLabel
} from "./initialOnboardingConfig";
import {useInitialOnboardingFlow} from "./useInitialOnboardingFlow";
import {useActivationProgressReporter} from "../V2Editor/activation/useActivationProgressReporter";
import {createActivationRun} from "../V2Editor/activation/runStore";
import WorkspaceSwitcher from "./WorkspaceSwitcher";
import V2AssistantSidebar from "../V2Editor/V2AssistantSidebar";
import {useEditorAssistant} from "../V2Editor/hooks/useEditorAssistant";

const kLibrettoCurrentProjectId = 'librettoCurrentProjectId';
const kLibrettoSortNewest = 'librettoSortNewest';
const kLibrettoGridView = 'librettoGridView';
const StripePromise = loadStripe('pk_live_51M1XiRBj7f2nVTUZCtLaBjIfMqKiA8OhnoQxOSddZwAJMktMfnlYz1pIrYVdxu9Yoato4ZIRjKZyv7oRp41OpDDJ00dgvuYP97');

const activationSampleRecordings = [
    // TODO: replace thumbnailUrl with production preview image URLs.
    // {
    //     id: "sample-conversation",
    //     title: "Interview conversation",
    //     description: "Edit multiple speakers, create scenes, and switch layouts in a guided demo.",
    //     thumbnailUrl: "https://image.mux.com/7KPB00FHt95IyQMvSgoe6auav7TZUyBlA6CMpk2g8JH4/thumbnail.png?width=214&height=121&time=1041",
    //     sourceUrl: "",
    //     mediaType: "video",
    //     presetTranscriptId: "",
    //     skipTranscription: false,
    // },
    {
        id: "sample-monologue",
        title: "Edit by transcript",
        projectName: "Guided Demo — Edit by Transcript",
        description: "Edit by transcript. Remove filler speech and pauses automatically.",
        thumbnailUrl: "",
        sourceUrl: "https://storage.googleapis.com/libretto-public-assets/media/podcast_cut_7min.m4a",
        mediaType: "audio",
        activationFlowId: "first_export_transcript",
        presetTranscriptId: "",
        skipTranscription: false,
        transcriptionDisabled: true,
        activeTranscriptionId: "t_vGI5lIFMrG82eHP_1774623067558",
    },
    {
        id: "sample-cleanup",
        title: "Clean up a recording",
        projectName: "Guided Demo — Clean Up a Recording",
        description: "Remove filler words, retakes, and tangents with Edit for clarity.",
        thumbnailUrl: "",
        sourceUrl: "https://storage.googleapis.com/libretto-public-assets/media/podcast_cut_7min.m4a",
        mediaType: "audio",
        activationFlowId: "first_export_clarity",
        presetTranscriptId: "",
        skipTranscription: false,
        transcriptionDisabled: true,
        activeTranscriptionId: "t_vGI5lIFMrG82eHP_1774623067558",
    },
    // {
    //     id: "sample-composite-zoom-recording",
    //     title: "Separate into speaker tracks",
    //     description: "Turn a Zoom-style recording into separate speaker tracks automatically.",
    //     thumbnailUrl: "https://image.mux.com/MuhmB12XDLKHuxloUdI02Huw3LkjDBkoLkVOFl3zW8ME/thumbnail.png?width=214&height=121&time=58",
    //     sourceUrl: "https://storage.googleapis.com/libretto-public-assets/media/ShortZoomRecording.mp4",
    //     mediaType: "video",
    //     activationFlowId: "first_export_composite",
    //     presetTranscriptId: "",
    //     skipTranscription: false,
    //     transcriptionDisabled: true,
    //     activeTranscriptionId: "t_wAF4LmvgY47eMlP_1772941412883",
    // },
];

const transcriptionInProgressStates = new Set(["queued", "processing", "client_extracting", "pending"]);
const transcriptionFailureStates = new Set(["failed", "cancelled"]);
const transcriptionNoSpeechStates = new Set(["silent", "not_needed"]);
const transcriptionCompletedState = "completed";
const homeWorkflowDialogTypes = {
    EDIT_BY_TRANSCRIPT: "home_edit_by_transcript",
    CLEAN_UP_RECORDING: "home_clean_up_recording",
    ENHANCE_AUDIO: "home_enhance_audio",
    EDIT_MULTI_SPEAKER: "home_edit_multi_speaker",
    ADD_CAPTIONS: "home_add_captions",
    CREATE_SOCIAL_CLIPS: "home_create_social_clips",
};

const inferSampleUploadFileType = ({mimeType, mediaType}) => {
    const safeMimeType = String(mimeType || "").toLowerCase();
    if (safeMimeType.startsWith("video/")) return "video";
    if (safeMimeType.startsWith("audio/")) return "audio";
    return mediaType === "video" ? "video" : "audio";
};

const normalizeActivationProgressUpdate = (update) => {
    if (!update || typeof update !== "object") return null;
    const title = String(update.title || "").trim();
    const detail = String(update.detail || "").trim();
    if (!title && !detail) return null;
    return {
        ...(title ? {title} : {}),
        ...(detail ? {detail} : {}),
    };
};

const createActivationSamplePrewarmEntry = (sampleId) => ({
    sampleId,
    status: "idle",
    promise: null,
    result: null,
    error: null,
    progress: null,
    listeners: new Set(),
});

const ensureActivationSamplePrewarmEntry = (storeRef, sampleId) => {
    const safeSampleId = String(sampleId || "").trim();
    if (!safeSampleId) return null;
    if (!storeRef.current[safeSampleId]) {
        storeRef.current[safeSampleId] = createActivationSamplePrewarmEntry(safeSampleId);
    }
    return storeRef.current[safeSampleId];
};

const subscribeToActivationSamplePrewarm = (entry, listener) => {
    if (!entry || typeof listener !== "function") return () => {};
    entry.listeners.add(listener);
    if (entry.progress) {
        try {
            listener(entry.progress);
        } catch (error) {
            console.warn("[AgenticHome] Activation sample progress listener failed", error);
        }
    }
    return () => {
        entry.listeners.delete(listener);
    };
};

const emitActivationSamplePrewarmProgress = (entry, update) => {
    if (!entry) return;
    entry.progress = normalizeActivationProgressUpdate(update);
    if (!entry.progress) return;
    entry.listeners.forEach((listener) => {
        try {
            listener(entry.progress);
        } catch (error) {
            console.warn("[AgenticHome] Activation sample progress listener failed", error);
        }
    });
};

const extensionFromMimeType = ({mimeType, mediaType}) => {
    const safeMimeType = String(mimeType || "").toLowerCase();
    if (safeMimeType.includes("wav")) return ".wav";
    if (safeMimeType.includes("mp3")) return ".mp3";
    if (safeMimeType.includes("ogg")) return ".ogg";
    if (safeMimeType.includes("webm")) return ".webm";
    if (safeMimeType.includes("aac")) return ".aac";
    if (safeMimeType.includes("flac")) return ".flac";
    if (safeMimeType.includes("mpeg")) return ".mp3";
    if (safeMimeType.includes("mp4") || safeMimeType.includes("quicktime")) {
        return mediaType === "video" ? ".mp4" : ".m4a";
    }
    return mediaType === "video" ? ".mp4" : ".m4a";
};

// Only show projects created on or after January 1, 2026 (Libretto V2 release)
const V2_RELEASE_TIMESTAMP = new Date("2026-01-01T00:00:00Z").getTime();

const urlFriendlyUserFriendlyRoomName = ({userFriendlyRoomName}) => {
    return userFriendlyRoomName.replace(/ /g, '-');
}

const guestURL = (roomName, userFriendlyRoomName) => {
    return CLIENT_URL + "/guest/" + roomName + "/" + urlFriendlyUserFriendlyRoomName({userFriendlyRoomName});
}

const NewProjectCard = ({newProjectTitle, setNewProjectTitle, onKeyDown, onClose, onClick}) => {

    const boxStyle = {
        display: "flex",
        flexDirection: "column",
        width: "486px",
        padding: "24px 24px 40px 24px",
        alignItems: "center",
        gap: "32px",
        borderRadius: "12px",
    }

    const headerStyle = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        alignSelf: "stretch",
    }

    const headerTextStyle = {
        fontFamily: "Inter",
        fontSize: 32,
        fontWeight: 500,
        lineHeight: "40px",
        letterSpacing: 0,
    };

    const textBoxStyle = {
        display: "flex",
        width: "100%",
    }

    const confirmButtonStyle = {
        display: "flex",
        height: "52px",
        padding: "10px 60px",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        background: "#2B6BFD",
        borderRadius: "6px",
        cursor: "pointer",
        // Hover effect
        '&:hover': {
            background: "linear-gradient(0deg, rgba(0, 0, 0, 0.10)0%, rgba(0, 0, 0, 0.10)100%), #2B6BFD",
        },
    }

    const buttonTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.14px",
        color: "#FFFFFF",
    }

    return (
        <Box style={boxStyle}>
            <Box style={headerStyle}>
                <Box style={headerTextStyle}>
                    Set the title of your new project
                </Box>
                <Box style={{display: "flex", marginLeft: "auto", cursor: "pointer"}} onClick={onClose}>
                    <CloseIcon/>
                </Box>
            </Box>
            <Box style={textBoxStyle}>
                <TextField
                    variant="outlined"
                    name="title"
                    fullWidth
                    onKeyDown={onKeyDown}
                    value={newProjectTitle}
                    onChange={(e) => setNewProjectTitle(e.target.value)}
                    margin="normal"
                    InputProps={{
                        style: {
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "20px",
                            letterSpacing: "0.14px",
                            color: "var(--app-text-primary)",
                            height: "64px",
                            backgroundColor: "var(--app-bg-surface)",
                        },
                    }}
                    InputLabelProps={{
                        style: {
                            color: "var(--app-text-subtle)",
                            fontFamily: 'Inter',
                            fontSize: '12px',
                            fontWeight: 400,
                        },
                        shrink: true,
                    }}
                    sx={{
                        width: '100%',
                        height: '64px',
                        marginTop: "10px",
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                border: "1px solid var(--app-border-subtle)",
                            },
                            '&:hover fieldset': {
                                border: "1px solid var(--app-border-muted)",
                            },
                            '&.Mui-focused fieldset': {
                                border: "1px solid var(--app-border-muted)",
                            },
                        },
                        '& .MuiInputBase-root': {
                            backgroundColor: "var(--app-bg-surface)",
                        },
                    }}
                />
            </Box>
            <Box sx={confirmButtonStyle} onClick={onClick}>
                <Box style={buttonTextStyle}>Confirm</Box>
            </Box>
        </Box>
    )
}

export const RecordingTypesContextMenu = ({
                                              setRecordingTypesMenuOpen,
                                              handleScreenRecordingClick,
                                              handleStudioClick
                                          }) => {

    const boxStyle = {
        position: "absolute",
        top: "70px",
        right: "390px",
        display: "inline-flex",
        padding: "16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "4px",
        borderRadius: "12px",
        background: "var(--app-bg-surface)",
        boxShadow: "0px 30px 80px 0px rgba(0, 0, 0, 0.15)",
        zIndex: 1000,
    }

    const itemStyle = {
        display: "flex",
        padding: "16px",
        alignItems: "center",
        gap: "8px",
        alignSelf: "stretch",
        cursor: "pointer",
        borderRadius: "8px",
        // On hover
        '&:hover': {
            background: "var(--app-bg-subtle)",
        },
    }

    const itemTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.14px",
        color: "var(--app-text-primary)",
    }

    const itemTextSubtitileStyle = {
        fontFamily: "Inter",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "16px",
    }

    return (
        <ClickAwayListener onClickAway={() => setRecordingTypesMenuOpen(false)}>
            <Card style={boxStyle}>
                <Box sx={itemStyle} onClick={handleScreenRecordingClick}>
                    <Box style={{display: "flex", height: "20px", width: "20px", marginBottom: "2px"}}>
                        <Laptop/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Screen Recording
                    </Box>
                </Box>
                <Box sx={itemStyle} onClick={handleStudioClick}>
                    <Box style={{display: "flex", height: "20px", width: "20px", marginBottom: "2px"}}>
                        <VideoCall/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Go to Studio
                    </Box>
                </Box>
            </Card>
        </ClickAwayListener>
    )
}

export const ScheduleRecordingContextMenu = ({
                                                 setScheduleRecordingMenuOpen,
                                                 handleInviteClick,
                                                 handleScheduleClick,
                                                 userId,
                                             }) => {

    const onInviteClick = () => {
        mixpanel.track('Invited_From_Home', {
            'userId': userId,
        });
        handleInviteClick();
    }

    const onScheduleClick = () => {
        mixpanel.track('Scheduling', {
            'userId': userId,
        });
        handleScheduleClick();
    }

    const boxStyle = {
        position: "absolute",
        top: "70px",
        right: "390px",
        display: "inline-flex",
        padding: "16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "4px",
        borderRadius: "12px",
        background: "var(--app-bg-surface)",
        boxShadow: "0px 30px 80px 0px rgba(0, 0, 0, 0.15)",
        zIndex: 1000,
    }

    const itemStyle = {
        display: "flex",
        padding: "16px",
        alignItems: "center",
        gap: "8px",
        alignSelf: "stretch",
        cursor: "pointer",
        borderRadius: "8px",
        // On hover
        '&:hover': {
            background: "var(--app-bg-subtle)",
        },
    }

    const itemTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.14px",
        color: "var(--app-text-primary)",
    }

    const itemTextSubtitileStyle = {
        fontFamily: "Inter",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "16px",
    }

    const disabledItemStyle = {
        display: "flex",
        padding: "16px",
        alignItems: "center",
        gap: "8px",
        alignSelf: "stretch",
        cursor: "not-allowed",
        borderRadius: "8px",
    }

    return (
        <ClickAwayListener onClickAway={() => setScheduleRecordingMenuOpen(false)}>
            <Card style={boxStyle}>
                <Box sx={itemStyle} onClick={onScheduleClick}>
                    <Box style={{display: "flex", height: "20px", width: "20px", marginBottom: "2px"}}>
                        <TodayOutlined/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Schedule session
                    </Box>
                </Box>
                <Box sx={itemStyle} onClick={onInviteClick}>
                    <Box style={{display: "flex", height: "20px", width: "20px", marginBottom: "2px"}}>
                        <InviteIcon color={"var(--app-icon-primary)"}/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Invite to record
                    </Box>
                </Box>
            </Card>
        </ClickAwayListener>
    )
}

const ProfileAvatarMenu = ({
                               setProfileAvatarMenuOpen,
                               profileMenuTop,
                               profileMenuRight,
                               handleLogoutClick,
                               handleSettingsClick,
                               themePreference,
                               handleThemePreferenceChange,
                               showThemeOption = false,
                           }) => {
    const [themeSubMenuOpen, setThemeSubMenuOpen] = useState(false);
    const menuWidth = 200;

    const boxStyle = {
        position: "fixed",
        top: profileMenuTop,
        right: profileMenuRight,
        display: "flex",
        padding: "8px",
        width: `${menuWidth}px`,
        flexDirection: "column",
        gap: "2px",
        borderRadius: "14px",
        background: "var(--app-bg-surface)",
        border: "1px solid var(--app-border-subtle)",
        boxShadow: "0px 20px 60px rgba(0, 0, 0, 0.12)",
        pointerEvents: "auto",
        zIndex: 1000,
    };

    const itemStyle = {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px 12px",
        cursor: "pointer",
        borderRadius: "10px",
        transition: "background 0.12s ease",
        "&:hover": {
            background: "var(--app-bg-canvas)",
        },
    };

    const itemTextStyle = {
        fontFamily: "Inter",
        fontSize: "13px",
        fontWeight: 500,
        lineHeight: "18px",
        letterSpacing: "0.1px",
        color: "var(--app-text-primary)",
    };

    const subtleIconStyle = {
        fontSize: "18px",
        color: "var(--app-icon-primary)",
    };

    const closeMenu = () => {
        setThemeSubMenuOpen(false);
        setProfileAvatarMenuOpen(false);
    };

    const handleThemeSelection = (nextPreference) => {
        handleThemePreferenceChange?.(nextPreference);
        closeMenu();
    };

    const themeSubMenuStyle = {
        position: "fixed",
        top: profileMenuTop + 8,
        right: profileMenuRight + menuWidth + 8,
        width: "160px",
        display: "flex",
        padding: "8px",
        flexDirection: "column",
        gap: "2px",
        borderRadius: "14px",
        background: "var(--app-bg-surface)",
        border: "1px solid var(--app-border-subtle)",
        boxShadow: "0px 20px 60px rgba(0, 0, 0, 0.12)",
        zIndex: 1001,
    };

    const themeOptions = [
        {label: "Light", value: "light"},
        {label: "Dark", value: "dark"},
        {label: "System", value: "system"},
    ];

    return (
        <ClickAwayListener onClickAway={closeMenu}>
            <Box>
                <Box sx={boxStyle}>
                    {showThemeOption && (
                        <Box
                            sx={itemStyle}
                            onClick={() => setThemeSubMenuOpen((open) => !open)}
                        >
                            <Brightness4OutlinedIcon style={subtleIconStyle}/>
                            <Box sx={itemTextStyle}>Theme</Box>
                            <KeyboardArrowRightIcon
                                sx={{marginLeft: "auto", fontSize: "18px", color: "var(--app-text-subtle)"}}/>
                        </Box>
                    )}
                    <Box
                        sx={itemStyle}
                        onClick={() => {
                            handleSettingsClick();
                            closeMenu();
                        }}
                    >
                        <SettingsIcon style={subtleIconStyle}/>
                        <Box sx={itemTextStyle}>Settings</Box>
                    </Box>
                    <Box sx={{height: "1px", background: "var(--app-border-subtle)", my: "6px"}}/>
                    <Box
                        sx={{
                            ...itemStyle,
                            "&:hover": {
                                background: "rgba(255,0,0,0.06)",
                            },
                        }}
                        onClick={() => {
                            handleLogoutClick();
                            closeMenu();
                        }}
                    >
                        <LogoutIcon style={{fontSize: "18px", color: "#C63636"}}/>
                        <Box sx={{...itemTextStyle, color: "#C63636"}}>
                            Log out
                        </Box>
                    </Box>
                </Box>
                {showThemeOption && themeSubMenuOpen && (
                    <Box sx={themeSubMenuStyle}>
                        {themeOptions.map((option) => (
                            <Box
                                key={option.value}
                                sx={itemStyle}
                                onClick={() => handleThemeSelection(option.value)}
                            >
                                <Box sx={{
                                    width: "18px",
                                    minWidth: "18px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    {themePreference === option.value && (
                                        <CheckIcon sx={{fontSize: "18px", color: "var(--app-text-primary)"}}/>
                                    )}
                                </Box>
                                <Box sx={itemTextStyle}>{option.label}</Box>
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>
        </ClickAwayListener>
    );
};

const ProjectsView = ({
                          projects,
                          setSwitchToComputerFormOpen,
                          showAsGrids,
                          isSharedView,
                          isMobile,
                          deleteProject,
                          handleProjectCardClick
                      }) => {
    if (showAsGrids && !isMobile) {
        return (
            <Grid container spacing={2} marginTop={1}>
                <GridProjects projects={projects} setSwitchToComputerFormOpen={setSwitchToComputerFormOpen}
                              deleteProject={deleteProject} handleProjectCardClick={handleProjectCardClick}/>
            </Grid>
        )
    }

    return (
        <>
            {/* List header row (flex ratios: 6 | 2 | 2 | 2) */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px 20px',
                    pr: '44px',
                    borderBottom: '1px solid var(--app-border-subtle)',
                    background: 'transparent',
                    gap: 2,
                    mb: 1,
                }}
            >
                {/* Name column: leave thumbnail spacer + label */}
                <Box sx={{flex: '6 1 0', minWidth: 0, display: 'flex', alignItems: 'center', gap: '16px'}}>
                    <Box sx={{width: '72px', height: '1px'}}/>
                    <Box sx={{
                        fontFamily: 'Inter',
                        fontSize: 12,
                        fontWeight: 500,
                        color: 'var(--app-text-muted)',
                    }}>Name</Box>
                </Box>
                {/* Duration */}
                <Box sx={{
                    flex: '2 1 0',
                    minWidth: 0,
                    fontFamily: 'Inter',
                    fontSize: 12,
                    fontWeight: 500,
                    color: 'var(--app-text-muted)',
                }}>
                    Duration
                </Box>
                {/* Created */}
                <Box sx={{
                    flex: '2 1 0',
                    minWidth: 0,
                    fontFamily: 'Inter',
                    fontSize: 12,
                    fontWeight: 500,
                    color: 'var(--app-text-muted)',
                }}>
                    Created
                </Box>
                {/* Last viewed */}
                <Box sx={{
                    flex: '2 1 0',
                    minWidth: 0,
                    fontFamily: 'Inter',
                    fontSize: 12,
                    fontWeight: 500,
                    color: 'var(--app-text-muted)',
                }}>
                    Last viewed
                </Box>
            </Box>
            {projects.map((project, i) => (
                <ListViewProject project={project} onClick={handleProjectCardClick} isMobile={isMobile}/>
            ))}
        </>
    )
}

const mainAreaStyle = (isMobile) => ({
    flex: 1,
    height: "100%",
    padding: isMobile ? "16px 16px 24px" : "24px 40px 32px",
    overflowY: "auto",
    overflowX: "hidden",
    display: "flex",
    justifyContent: "flex-start",
});

const mainInnerStyle = (isMobile, maxWidth) => ({
    width: "100%",
    maxWidth,
    margin: isMobile ? "0 auto" : "0 auto",
});

const headerButtonsStyle = (isMobile) => {
    return {
        display: isMobile ? "none" : "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        gap: "8px",
    }
}

const topAreaStyle = (isMobile) => {
    return {
        display: isMobile ? "none" : "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    }
}

const logoBoxStyle = {
    display: "flex",
    padding: "20px 12px",
    alignItems: "center",
    gap: "2px",
    alignSelf: "stretch",
    marginBottom: "24px",
    cursor: "pointer",
}


const effectiveRecordingsStyle = (showAsGrid) => ({
    marginTop: 8,
    padding: showAsGrid ? "4px 0" : 0,
    borderRadius: 12,
    backgroundColor: "var(--app-bg-surface)",
    border: "1px solid var(--app-border-subtle)",
});

const AgenticHome = () => {

    const theme = useTheme();
    const isDarkMode = theme.palette.mode === "dark";
    const {themePreference, setThemePreference} = useThemeMode();
    const isOffline = useIsOffline();
    const selectedNavBackground = isDarkMode ? "rgba(43, 107, 253, 0.22)" : "#EFF4FE";
    const newProjectIconBackground = isDarkMode ? "rgba(43, 107, 253, 0.2)" : "#EFF4FE";
    const newProjectIconHoverBackground = isDarkMode ? "rgba(43, 107, 253, 0.28)" : "rgba(43, 107, 253, 0.20)";
    const topProfileInitialBackground = isDarkMode ? "#2B6BFD" : "#000000";
    const trialBannerBorderColor = isDarkMode
        ? alpha(theme.palette.primary.main, 0.5)
        : alpha(theme.palette.primary.main, 0.28);
    const trialBannerBackground = isDarkMode
        ? alpha(theme.palette.primary.main, 0.24)
        : alpha(theme.palette.primary.main, 0.14);

    const collapsedSidebarNavButtonSx = (selected) => ({
        color: selected ? "#2B6BFD" : "var(--app-text-muted)",
        backgroundColor: selected ? selectedNavBackground : "transparent",
        borderRadius: "8px",
        padding: "12px",
        "&:hover": {
            backgroundColor: selected ? selectedNavBackground : "var(--app-bg-subtle)",
        },
    });

    const navigate = useNavigate();
    const location = useLocation();

    const {CreateProject, CreateComposition, UploadAsset} = useAssetStore();

    const [sidebarCollapsed, setSidebarCollapsed] = useState(true);

    const [projects, setProjects] = useState([]);
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProjectAssets, setCurrentProjectAssets] = useState([]);
    const [sortedAssets, setSortedAssets] = useState([]);
    const [sortedProjects, setSortedProjects] = useState([]);
    const [sortNewest, setSortNewest] = useState(() => {
        const stored = sessionStorage.getItem(kLibrettoSortNewest);
        return stored !== null ? stored === 'true' : true;
    });
    const [showAsGrids, setShowAsGrids] = useState(() => {
        const stored = sessionStorage.getItem(kLibrettoGridView);
        return stored !== null ? stored === 'true' : false;
    });
    const authContext = useContext(AuthContext);
    const userId = authContext.authState?.userId || authContext.getUserId?.();

    // Set page title
    useEffect(() => {
        document.title = "Libretto";
    }, []);

    const ViewState = {
        HOME: 'HOME',
        PROJECTS: 'PROJECTS',
        SINGLE_PROJECT: 'SINGLE_PROJECT',
        CREATE_SESSION: 'CREATE_SESSION',
        LEGACY_PROJECTS: 'LEGACY_PROJECTS',
    };

    const [currentView, setCurrentView] = useState(ViewState.HOME);
    const editForClarityNavigatingRef = useRef(false);
    const uploadAndEditNavigatingRef = useRef(false);
    const addCaptionsNavigatingRef = useRef(false);
    const enhanceAudioNavigatingRef = useRef(false);
    const multiSpeakerNavigatingRef = useRef(false);
    const activationSamplePrewarmRef = useRef({});
    const activationSamplePrewarmStartedRef = useRef(false);

    const [currentProjectTitle, setCurrentProjectTitle] = useState("");

    // console.log("Current project id:", currentProjectId);

    const fetchContext = useContext(FetchContext);
    const currentWorkspaceId = authContext.authState?.currentWorkspaceId || authContext.getCurrentWorkspaceId?.();
    const workspaces = authContext.authState?.workspaces || authContext.getWorkspaces?.() || [];

    const hasUpgradeIntent = authContext.hasUpgradeIntent();

    useEffect(() => {
        activationSamplePrewarmRef.current = {};
        activationSamplePrewarmStartedRef.current = false;
    }, [userId, currentWorkspaceId]);

    useEffect(() => {
        if (hasUpgradeIntent) {
            authContext.clearUpgradeIntent();
            navigate("/dashboard?settings=plan", {replace: true});
        }
    }, [hasUpgradeIntent]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const currentCheckoutStatus = params.get("checkout");
        const requestedSettingsTab = params.get("settings");
        const wantsSettings =
            requestedSettingsTab === "plan" ||
            requestedSettingsTab === "profile" ||
            requestedSettingsTab === "usage" ||
            requestedSettingsTab === "invites" ||
            requestedSettingsTab === "appsumo" ||
            requestedSettingsTab === "members";
        const sessionId = params.get("session_id");
        setCheckoutStatus(currentCheckoutStatus);
        if (currentCheckoutStatus === "success") {
            setIsCheckoutProcessing(true);
        }
        if (currentCheckoutStatus || wantsSettings) {
            const tabToOpen =
                currentCheckoutStatus || sessionId
                    ? "plan"
                    : requestedSettingsTab || "profile";
            openSettingsModal(tabToOpen);
        }
        const processCheckoutSuccess = async () => {
            if (!sessionId || currentCheckoutStatus !== "success") return;
            const processedKey = `librettoCheckoutProcessed:${sessionId}`;
            if (sessionStorage.getItem(processedKey) === "true") return;
            sessionStorage.setItem(processedKey, "true");
            try {
                await fetchContext.authAxios.get(`/checkout/success/${sessionId}`, {
                    headers: {
                        Authorization: `Bearer ${authContext.getToken()}`,
                    },
                });
            } catch (error) {
                console.error("Error confirming checkout success:", error);
            }
        };
        processCheckoutSuccess().finally(() => {
            if (currentCheckoutStatus || wantsSettings || sessionId) {
                const cleaned = new URL(window.location.href);
                cleaned.searchParams.delete("checkout");
                cleaned.searchParams.delete("settings");
                cleaned.searchParams.delete("success");
                cleaned.searchParams.delete("canceled");
                cleaned.searchParams.delete("session_id");
                window.history.replaceState({}, "", cleaned.pathname + cleaned.search);
            }
        });
    }, [location.search, authContext, fetchContext]);

    const userPlan = authContext.authState?.userPlan ?? authContext.getUserPlan();
    const normalizedUserPlan = String(userPlan ?? "").trim();
    const isLifetimePlanUser =
        normalizedUserPlan === String(LibrettoPlan.StudioLifetime) ||
        normalizedUserPlan === "6" ||
        normalizedUserPlan === "7" ||
        [10, 11, 12, 13].includes(Number(normalizedUserPlan));

    // Plan access is currently unrestricted. Keep plan identity for account UI,
    // but do not use it to block projects, recording, uploads, or editing.
    const isFreePlan = false;

    const [threeDotsMenuOpen, setThreeDotsMenuOpen] = useState(false);
    const [threeDotsMenuRight, setThreeDotsMenuRight] = useState(0);
    const [threeDotsMenuTop, setThreeDotsMenuTop] = useState(0);

    const [isEditingTitle, setIsEditingTitle] = useState(false);
    const [titleCreationCardOpen, setTitleCreationCardOpen] = useState(false);
    const [titleCreationProjectId, setTitleCreationProjectId] = useState(null);

    const [recordingTypesMenuOpen, setRecordingTypesMenuOpen] = useState(false);
    const [scheduleRecordingMenuOpen, setScheduleRecordingMenuOpen] = useState(false);
    const [showScheduleForm, setShowScheduleForm] = useState(false);
    const [showInviteForm, setShowInviteForm] = useState(false);

    const [invitedEmails, setInvitedEmails] = useState([]);
    const [roomName, setRoomName] = useState('');
    const [userFriendlyRoomName, setUserFriendlyRoomName] = useState('');
    const [userBillingState, setUserBillingState] = useState({
        subscriptionStatus: null,
        trialEndDate: null,
        stripeHasPaymentMethod: null,
        hasSeenTrialModal: false,
        hasCompletedInitialOnboarding: false,
        onboardingRole: "",
        onboardingFirstThingToSee: "",
        loaded: false,
    });
    const [trialBannerDismissed, setTrialBannerDismissed] = useState(false);
    const [isCheckoutStarting, setIsCheckoutStarting] = useState(false);
    const [checkoutStatus, setCheckoutStatus] = useState(null);
    const [isCheckoutProcessing, setIsCheckoutProcessing] = useState(false);

    const [switchToComputerFormOpen, setSwitchToComputerFormOpen] = useState(false);

    const [profileAvatarMenuOpen, setProfileAvatarMenuOpen] = useState(false);
    const [profileMenuTop, setProfileMenuTop] = useState(0);
    const [profileMenuRight, setProfileMenuRight] = useState(0);
    const [settingsModalOpen, setSettingsModalOpen] = useState(false);
    const [settingsActiveTab, setSettingsActiveTab] = useState("profile");

    const [newProjectTitle, setNewProjectTitle] = useState('My Project');

    const [showUploadCard, setShowUploadCard] = useState(false);
    const [assistantDrawerOpen, setAssistantDrawerOpen] = useState(false);
    const [assistantActionError, setAssistantActionError] = useState(null);

    const [uploadCardWorkflowType, setUploadCardWorkflowType] = useState(null);

    const [showShareProjectCard, setShowShareProjectCard] = useState(false);

    const [editButtonLoading, setEditButtonLoading] = useState(false);

    const [recordSomethingMenuPosition, setRecordSomethingMenuPosition] = useState({});

    const recordSomethingButtonRef = useRef(null);
    const headerRecordButtonRef = useRef(null);
    const recordSomethingMenuAnchorRef = useRef(null);

    const [recordSomethingMenuOpen, setRecordSomethingMenuOpen] = useState(false);

    const auth = authContext;
    const isMobile = useMediaQuery('(max-width: 999px)');
    const {
        initialOnboardingStep,
        initialOnboardingRole,
        initialOnboardingFirstThingToSee,
        initialOnboardingDemoPlaybackId,
        activationModalAutoAction,
        trialModalOpen,
        isReopenedActivationModal,
        handleInitialOnboardingRoleSelect,
        handleInitialOnboardingFirstThingSelect,
        handleContinueInitialOnboardingMobileDemo,
        handleEmailMeLibrettoLink,
        markTrialModalSeen,
        handleCloseTrialModal,
        handleOpenActivationModal,
        hideTrialModal,
    } = useInitialOnboardingFlow({
        userId,
        currentWorkspaceId,
        authContext,
        userBillingState,
        setUserBillingState,
        isMobile,
        isLifetimePlanUser,
    });
    const {reportActivationProgress} = useActivationProgressReporter({
        authAxios: fetchContext?.authAxios,
        getToken: authContext?.getToken,
    });

    // If the user chose "Record something new", skip the activation modal and go straight to record mode.
    const [hasHandledRecordVideoAutoAction, setHasHandledRecordVideoAutoAction] = useState(false);
    useEffect(() => {
        if (isFreePlan || isLifetimePlanUser) return;
        if (hasHandledRecordVideoAutoAction) return;
        if (!trialModalOpen) return;
        if (activationModalAutoAction?.type !== "record_video") return;
        setHasHandledRecordVideoAutoAction(true);
        handleCloseTrialModal();
        (async () => {
            const projectId = await CreateProject();
            const run = createActivationRun({
                flowId: "first_record_video",
                source: "initial_onboarding_record_video",
                projectId,
            });
            const params = new URLSearchParams();
            params.set("mode", "recording");
            params.set("type", "video");
            if (run?.id) params.set("activationRunId", run.id);
            navigate("/editor/" + projectId + "?" + params.toString());
        })();
    }, [isFreePlan, isLifetimePlanUser, trialModalOpen, activationModalAutoAction, hasHandledRecordVideoAutoAction, handleCloseTrialModal, navigate]);

    const subscriptionStatus = String(userBillingState.subscriptionStatus || "").toLowerCase();
    const isTrialing = subscriptionStatus === "trialing";
    const isBeforeTrial = subscriptionStatus === "not_created";
    const isInactiveAfterTrial =
        subscriptionStatus !== "" &&
        subscriptionStatus !== "active" &&
        subscriptionStatus !== "trialing" &&
        subscriptionStatus !== "not_created";
    const hasPaymentMethod = userBillingState.stripeHasPaymentMethod === true;
    const trialEndMillis = normalizeTimestampToMillis(userBillingState.trialEndDate);
    const trialDaysLeft = trialEndMillis == null
        ? null
        : Math.max(0, Math.ceil((trialEndMillis - Date.now()) / (1000 * 60 * 60 * 24)));
    const trialPlanDetails = GetLibrettoTrialPlanDetails(userPlan);
    const trialPlanRecurringPriceText = trialPlanDetails.recurringPriceLabel;
    const trialPlanName = trialPlanDetails.name;
    const urgentTrialThresholdDays = 1;
    const isUrgentTrialWindow = trialDaysLeft != null && trialDaysLeft <= urgentTrialThresholdDays;
    const trialingBannerText = trialDaysLeft == null
        ? `Free trial active. Add a payment method to continue the ${trialPlanName} plan (${trialPlanRecurringPriceText}).`
        : isUrgentTrialWindow
            ? `Your free trial ends soon. Add a payment method to continue the ${trialPlanName} plan (${trialPlanRecurringPriceText}).`
            : `${trialDaysLeft} days left in your free trial. Add a payment method to continue the ${trialPlanName} plan (${trialPlanRecurringPriceText}).`;
    const trialBannerText = isTrialing
        ? trialingBannerText
        : isBeforeTrial
            ? "Your Studio trial starts on your first export."
            : `Your trial has ended. Add a payment method to continue using the ${trialPlanName} plan (${trialPlanRecurringPriceText}).`;
    const shouldShowTrialBanner =
        !isFreePlan &&
        !isLifetimePlanUser &&
        userBillingState.loaded &&
        !hasPaymentMethod &&
        !trialBannerDismissed &&
        (isTrialing || isBeforeTrial || isInactiveAfterTrial);

    useEffect(() => {
        if (!isCheckoutProcessing) return;
        if (hasPaymentMethod) {
            setIsCheckoutProcessing(false);
            return;
        }
        const timeoutId = setTimeout(() => {
            setIsCheckoutProcessing(false);
        }, 10000);
        return () => clearTimeout(timeoutId);
    }, [isCheckoutProcessing, hasPaymentMethod]);

    useEffect(() => {
        if (!userId) return;
        const key = `librettoTrialBannerDismissed:${userId}`;
        setTrialBannerDismissed(sessionStorage.getItem(key) === "true");
    }, [userId]);

    // Check for legacy projects (from login response)
    const hasLegacyProjects = authContext.getHasLegacyProjects();

    useEffect(() => {
        const fetchUserData = async () => {
            // Don't query Firestore unless user is fully authenticated
            if (!userId || !auth.isUserAuthenticated()) return;
        };
        fetchUserData();
    }, [userId, auth]);

    const waitForTrackTranscriptionReady = useCallback(({trackId, onProgress}) => {
        const safeTrackId = String(trackId || "").trim();
        if (!safeTrackId) {
            return Promise.reject(new Error("Missing track id for transcription monitoring."));
        }

        return new Promise((resolve, reject) => {
            let settled = false;
            let unsubscribe = () => {};
            const timeoutId = window.setTimeout(() => {
                if (settled) return;
                settled = true;
                unsubscribe();
                reject(new Error("Transcription is taking too long. Please try again."));
            }, 12 * 60 * 1000);

            const finish = (fn, value) => {
                if (settled) return;
                settled = true;
                clearTimeout(timeoutId);
                unsubscribe();
                fn(value);
            };

            const trackRef = doc(db, kTracksCollectionName, safeTrackId);
            unsubscribe = onSnapshot(
                trackRef,
                (snapshot) => {
                    if (!snapshot.exists()) {
                        onProgress?.({
                            title: "Preparing transcription",
                            detail: "Waiting for track processing to begin.",
                        });
                        return;
                    }

                    const trackData = snapshot.data() || {};
                    const state = String(trackData.transcriptionState || "").toLowerCase();

                    if (transcriptionFailureStates.has(state)) {
                        finish(reject, new Error("Sample transcription failed. Please try another sample."));
                        return;
                    }

                    if (transcriptionNoSpeechStates.has(state)) {
                        finish(reject, new Error("This sample has no usable speech audio."));
                        return;
                    }

                    if (state === transcriptionCompletedState) {
                        finish(resolve, {
                            projectId: String(trackData.projectId || "").trim(),
                        });
                        return;
                    }

                    if (transcriptionInProgressStates.has(state)) {
                        onProgress?.({
                            title: "Transcribing sample",
                            detail: "Analyzing speech and preparing your composition.",
                        });
                        return;
                    }

                    onProgress?.({
                        title: "Preparing transcription",
                        detail: "Waiting for transcription to start.",
                    });
                },
                (error) => {
                    const messageLower = String(error?.message || "").toLowerCase();
                    const isPrimaryLeaseIssue =
                        messageLower.includes("primary lease") || messageLower.includes("indexeddb");
                    if (isPrimaryLeaseIssue) {
                        console.warn("[AgenticHome] Sample transcription watcher IndexedDB lease contention (benign):", error?.code || error);
                        return;
                    }
                    finish(reject, new Error("Could not monitor sample processing status."));
                }
            );
        });
    }, []);

    const prepareActivationUpload = async ({
                                                file,
                                                filetype,
                                                onProgress,
                                                uploadDetail,
                                                waitForTranscription = true,
                                                skipTranscription = false,
                                                presetTranscriptId = "",
                                                transcriptionDisabled = false,
                                                activeTranscriptionId = "",
                                                activationFlowId = "",
                                                activationSampleId = "",
                                                activationSampleProjectName = "",
                                            }) => {
        let resolvedProjectId = "";
        let resolvedTrackId = "";
        let resolvedAssetId = "";
        let transcriptionWatcherPromise = null;
        let activationProjectTagPromise = null;
        const safePresetTranscriptId = String(presetTranscriptId || "").trim();
        const safeActiveTranscriptionId = String(activeTranscriptionId || "").trim();
        const safeActivationFlowId = String(activationFlowId || "").trim();
        const shouldDisableTranscription = Boolean(transcriptionDisabled) || Boolean(safeActiveTranscriptionId);
        const shouldSkipTranscription = Boolean(skipTranscription) || Boolean(safePresetTranscriptId) || shouldDisableTranscription;
        const shouldWaitForTranscription = waitForTranscription && !shouldSkipTranscription;
        onProgress?.({
            title: "Uploading recording",
            detail: uploadDetail || "Creating your project and track.",
        });

        await UploadAsset({
            projectId: "",
            projectType: LibrettoProjectTypes.ProjectTypeEditor,
            file,
            filetype,
            languageCode: "auto",
            queueEnhancementOnUpload: false,
            skipTranscription: shouldSkipTranscription,
            presetTranscriptId: safePresetTranscriptId,
            transcriptionDisabled: shouldDisableTranscription,
            activeTranscriptionId: safeActiveTranscriptionId,
            onUploadInitiated: ({assetId: initiatedAssetId, trackId: initiatedTrackId, projectId: initiatedProjectId}) => {
                resolvedAssetId = String(initiatedAssetId || "").trim();
                resolvedTrackId = String(initiatedTrackId || "").trim();
                resolvedProjectId = String(initiatedProjectId || "").trim();

                const safeActivationSampleId = String(activationSampleId || "").trim();
                const safeActivationSampleProjectName = String(activationSampleProjectName || "").trim();
                if (safeActivationSampleId && resolvedProjectId) {
                    activationProjectTagPromise = updateDoc(
                        doc(db, kProjectsCollectionName, resolvedProjectId),
                        {
                            activationSample: true,
                            activationSampleId: safeActivationSampleId,
                            activationSampleStatus: "prewarmed",
                            ...(safeActivationSampleProjectName
                                ? {[ProjectName]: safeActivationSampleProjectName}
                                : {}),
                        }
                    );
                }

                if (shouldWaitForTranscription && !transcriptionWatcherPromise && resolvedTrackId) {
                    transcriptionWatcherPromise = waitForTrackTranscriptionReady({
                        trackId: resolvedTrackId,
                        onProgress,
                    });
                }
            },
        });

        if (activationProjectTagPromise) {
            await activationProjectTagPromise;
        }

        if (shouldWaitForTranscription) {
            if (!transcriptionWatcherPromise) {
                throw new Error("Could not start processing.");
            }

            await transcriptionWatcherPromise;
        } else {
            onProgress?.({
                title: "Applying preset transcript",
                detail: "Skipping transcription for this demo sample.",
            });
        }

        if (!resolvedProjectId || !resolvedAssetId) {
            throw new Error("Upload completed without required identifiers.");
        }

        onProgress?.({
            title: "Preparing composition",
            detail: "Finishing your composition so it's ready to open.",
        });

        const compositionId = await resolveCompositionIdForProject(resolvedProjectId);
        if (!compositionId) {
            throw new Error("Could not create composition for this recording.");
        }

        return {
            projectId: resolvedProjectId,
            trackId: resolvedTrackId,
            assetId: resolvedAssetId,
            compositionId,
            activationFlowId: safeActivationFlowId,
        };
    };

    const openPreparedActivationEditor = async ({
                                                    prepared,
                                                    onProgress,
                                                    startActivationFlow = true,
                                                    reportInitialOnboardingProgress = false,
                                                }) => {
        const resolvedProjectId = String(prepared?.projectId || "").trim();
        const resolvedAssetId = String(prepared?.assetId || "").trim();
        const resolvedCompositionId = String(prepared?.compositionId || "").trim();
        const safeActivationFlowId = String(prepared?.activationFlowId || "").trim();

        if (!resolvedProjectId || !resolvedAssetId || !resolvedCompositionId) {
            throw new Error("Prepared sample is missing project details.");
        }

        if (prepared?.sampleId) {
            const sampleProjectName = String(prepared?.sampleProjectName || "").trim();
            await updateDoc(doc(db, kProjectsCollectionName, resolvedProjectId), {
                activationSample: true,
                activationSampleId: String(prepared.sampleId).trim(),
                activationSampleStatus: "selected",
                ...(sampleProjectName ? {[ProjectName]: sampleProjectName} : {}),
            });
        }

        onProgress?.({
            title: "Opening editor",
            detail: "Loading your composition.",
        });

        const params = new URLSearchParams();
        params.set("uploadAutoinsert", "1");
        params.set("uploadAssetId", resolvedAssetId);
        params.set("uploadCompositionId", resolvedCompositionId);
        if (startActivationFlow && safeActivationFlowId) {
            const run = createActivationRun({
                flowId: safeActivationFlowId,
                source: "first_export_activation_modal",
                projectId: resolvedProjectId,
            });
            if (run?.id) {
                if (reportInitialOnboardingProgress) {
                    const safeRoleValue = String(
                        initialOnboardingRole || userBillingState.onboardingRole || ""
                    ).trim();
                    const safeFirstThingValue = String(
                        initialOnboardingFirstThingToSee || userBillingState.onboardingFirstThingToSee || ""
                    ).trim();

                    if (safeRoleValue) {
                        reportActivationProgress({
                            runId: run.id,
                            flowId: run.flowId,
                            status: "running",
                            currentStepIndex: 0,
                            currentStepId: `onboarding_a_role_selected_${safeRoleValue}`,
                            currentStepLabel: "A",
                            currentStepTitle: `${getInitialOnboardingRoleLabel(safeRoleValue)} role selected`,
                            source: run.source,
                            projectId: run.projectId,
                            metadata: {
                                onboardingStage: "A",
                                onboardingRole: safeRoleValue,
                            },
                        });
                    }

                    if (safeFirstThingValue) {
                        reportActivationProgress({
                            runId: run.id,
                            flowId: run.flowId,
                            status: "running",
                            currentStepIndex: 0,
                            currentStepId: `onboarding_b_first_thing_selected_${safeFirstThingValue}`,
                            currentStepLabel: "B",
                            currentStepTitle: `${getInitialOnboardingFirstThingLabel(safeFirstThingValue)} selected`,
                            source: run.source,
                            projectId: run.projectId,
                            metadata: {
                                onboardingStage: "B",
                                onboardingFirstThingToSee: safeFirstThingValue,
                            },
                        });
                    }
                }
                params.set("activationRunId", run.id);
            }
        }

        void markTrialModalSeen();
        hideTrialModal();
        navigate(`/editor/${resolvedProjectId}?${params.toString()}`);
    };

    const downloadActivationSampleFile = async (sample, {onProgress} = {}) => {
        const sampleId = String(sample?.id || "").trim();
        const sampleTitle = String(sample?.title || "sample").trim();
        const sourceUrl = String(sample?.sourceUrl || "").trim();
        if (!sourceUrl) {
            throw new Error("Sample URL is not configured yet.");
        }

        onProgress?.({
            title: `Starting with ${sampleTitle}`,
            detail: "Downloading sample media.",
        });

        let response;
        try {
            response = await fetch(sourceUrl, {mode: "cors", credentials: "omit"});
        } catch (error) {
            console.error("[AgenticHome] Failed to download sample media", error);
            throw new Error("Could not download the sample. Please try again.");
        }

        if (!response.ok) {
            throw new Error(`Could not download sample media (HTTP ${response.status}).`);
        }

        const sampleBlob = await response.blob();
        if (!sampleBlob || sampleBlob.size <= 0) {
            throw new Error("Sample media file is empty.");
        }

        const mediaType = String(sample?.mediaType || "").toLowerCase() === "video" ? "video" : "audio";
        const fallbackMimeType = mediaType === "video" ? "video/mp4" : "audio/mpeg";
        const resolvedMimeType = String(sampleBlob.type || fallbackMimeType).toLowerCase();
        const extension = extensionFromMimeType({mimeType: resolvedMimeType, mediaType});
        const fileName = `${sampleId || "sample"}${extension}`;
        const sampleFile = new File([sampleBlob], fileName, {type: resolvedMimeType});
        const filetype = inferSampleUploadFileType({
            mimeType: resolvedMimeType,
            mediaType,
        });

        return {
            file: sampleFile,
            filetype,
        };
    };

    const resolveExistingActivationSampleProject = async (sample) => {
        const sampleId = String(sample?.id || "").trim();
        if (!sampleId) return null;

        const candidates = projects
            .filter((project) => String(project?.activationSampleId || "").trim() === sampleId)
            .sort((a, b) => {
                const aSelected = String(a?.activationSampleStatus || "").trim() === "selected" ? 1 : 0;
                const bSelected = String(b?.activationSampleStatus || "").trim() === "selected" ? 1 : 0;
                if (aSelected !== bSelected) return bSelected - aSelected;
                const aTime = normalizeTimestampToMillis(a?.lastViewed || a?.createTime) || 0;
                const bTime = normalizeTimestampToMillis(b?.lastViewed || b?.createTime) || 0;
                return bTime - aTime;
            });

        for (const project of candidates) {
            const projectId = String(project?.projectId || "").trim();
            if (!projectId) continue;

            let assetId = String(project?.activationSampleAssetId || "").trim();
            let compositionId = String(project?.activationSampleCompositionId || "").trim();

            if (!assetId) {
                const assetsSnapshot = await getDocs(query(
                    collection(db, kAssetsCollectionName),
                    where(AssetProjectId, "==", projectId),
                    where(AssetDeleted, "==", false)
                ));
                const assetDoc = assetsSnapshot.docs[0];
                assetId = String(assetDoc?.data()?.[AssetId] || assetDoc?.id || "").trim();
            }

            if (!compositionId) {
                compositionId = String(await resolveCompositionIdForProject(projectId) || "").trim();
            }

            if (!assetId || !compositionId) continue;

            const prepared = {
                projectId,
                assetId,
                compositionId,
                activationFlowId: String(sample?.activationFlowId || "").trim(),
                sampleId,
                sampleProjectName: String(sample?.projectName || "").trim(),
            };

            await updateDoc(doc(db, kProjectsCollectionName, projectId), {
                activationSampleAssetId: assetId,
                activationSampleCompositionId: compositionId,
                activationSampleFlowId: prepared.activationFlowId,
            });
            return prepared;
        }

        return null;
    };

    const prepareActivationSampleProject = async (sample, {onProgress, retryOnFailure = false} = {}) => {
        if (isFreePlan) throw new Error("Upgrade your plan to create projects.");
        const sampleId = String(sample?.id || "").trim();
        const sampleTitle = String(sample?.title || "sample").trim();
        if (!sampleId) {
            throw new Error("Sample id is not configured yet.");
        }

        const existingPrepared = await resolveExistingActivationSampleProject(sample);
        if (existingPrepared) {
            onProgress?.({
                title: `${sampleTitle} is ready`,
                detail: "Opening your existing demo project.",
            });
            return existingPrepared;
        }

        const entry = ensureActivationSamplePrewarmEntry(activationSamplePrewarmRef, sampleId);
        if (!entry) {
            throw new Error("Could not initialize sample preload state.");
        }

        const unsubscribeProgress = subscribeToActivationSamplePrewarm(entry, onProgress);
        try {
            if (entry.status === "ready" && entry.result) {
                return entry.result;
            }

            if (entry.promise) {
                try {
                    return await entry.promise;
                } catch (error) {
                    if (!retryOnFailure || entry.status !== "failed") {
                        throw error;
                    }
                }
            }

            if (entry.status === "failed" && !retryOnFailure) {
                throw entry.error || new Error("Could not prepare this demo yet.");
            }

            entry.status = "preparing";
            entry.result = null;
            entry.error = null;
            entry.progress = null;

            const progressHandler = (update) => {
                emitActivationSamplePrewarmProgress(entry, update);
            };

            const startPromise = (async () => {
                const samplePresetTranscriptId = String(sample?.presetTranscriptId || "").trim();
                const sampleActiveTranscriptionId = String(sample?.activeTranscriptionId || "").trim();
                const sampleTranscriptionDisabled =
                    Boolean(sample?.transcriptionDisabled) || Boolean(sampleActiveTranscriptionId);
                const sampleSkipTranscription =
                    Boolean(sample?.skipTranscription) ||
                    Boolean(samplePresetTranscriptId) ||
                    sampleTranscriptionDisabled;

                try {
                    const {file, filetype} = await downloadActivationSampleFile(sample, {
                        onProgress: progressHandler,
                    });

                    const prepared = await prepareActivationUpload({
                        file,
                        filetype,
                        onProgress: progressHandler,
                        uploadDetail: "Creating your sample project and track.",
                        waitForTranscription: !sampleSkipTranscription,
                        skipTranscription: sampleSkipTranscription,
                        presetTranscriptId: samplePresetTranscriptId,
                        transcriptionDisabled: sampleTranscriptionDisabled,
                        activeTranscriptionId: sampleActiveTranscriptionId,
                        activationFlowId: String(sample?.activationFlowId || "").trim(),
                        activationSampleId: sampleId,
                        activationSampleProjectName: String(sample?.projectName || "").trim(),
                    });

                    await updateDoc(doc(db, kProjectsCollectionName, prepared.projectId), {
                        activationSample: true,
                        activationSampleId: sampleId,
                        activationSampleStatus: "prewarmed",
                        activationSampleAssetId: prepared.assetId,
                        activationSampleCompositionId: prepared.compositionId,
                        activationSampleFlowId: prepared.activationFlowId,
                    });

                    const readyPayload = {
                        ...prepared,
                        sampleId,
                        sampleProjectName: String(sample?.projectName || "").trim(),
                    };

                    entry.status = "ready";
                    entry.result = readyPayload;
                    entry.error = null;
                    emitActivationSamplePrewarmProgress(entry, {
                        title: `${sampleTitle} is ready`,
                        detail: "Opening the editor as soon as you choose this demo.",
                    });
                    return readyPayload;
                } catch (error) {
                    entry.status = "failed";
                    entry.error = error;
                    throw error;
                } finally {
                    entry.promise = null;
                }
            })();

            entry.promise = startPromise;
            return await startPromise;
        } finally {
            unsubscribeProgress();
        }
    };

    useEffect(() => {
        if (isFreePlan) return;
        if (!userId || !userBillingState.loaded) return;
        if (userBillingState.hasSeenTrialModal) return;
        if (isMobile) return;
        if (isLifetimePlanUser) return;
        if (!userBillingState.hasCompletedInitialOnboarding || !trialModalOpen) return;
        if (activationSamplePrewarmStartedRef.current) return;

        activationSamplePrewarmStartedRef.current = true;
        activationSampleRecordings.forEach((sample) => {
            const sampleId = String(sample?.id || "").trim();
            if (!sampleId) return;
            void prepareActivationSampleProject(sample).catch((error) => {
                console.warn(`[AgenticHome] Failed to prewarm activation sample ${sampleId}`, error);
            });
        });
    }, [
        userId,
        isFreePlan,
        userBillingState.loaded,
        userBillingState.hasCompletedInitialOnboarding,
        userBillingState.hasSeenTrialModal,
        isLifetimePlanUser,
        isMobile,
        trialModalOpen,
    ]);

    const handleStartTranscriptActivation = async () => {
        const sample = activationSampleRecordings.find(
            (item) => String(item?.activationFlowId || "").trim() === "first_export_transcript"
        );
        if (!sample) return;
        trackSessionEvent("clicked_banner_start_transcript_activation");
        const prepared = await prepareActivationSampleProject(sample, { retryOnFailure: true });
        await openPreparedActivationEditor({ prepared, reportInitialOnboardingProgress: true });
    };

    const handleUseSampleTranscript = async () => {
        const sample = activationSampleRecordings.find(
            (item) => String(item?.activationFlowId || "").trim() === "first_export_transcript"
        );
        if (!sample) return;
        trackSessionEvent("clicked_workflow_use_sample_transcript");
        setShowUploadCard(false);
        const prepared = await prepareActivationSampleProject(sample, { retryOnFailure: true });
        await openPreparedActivationEditor({ prepared, startActivationFlow: false });
    };

    const handleTrySampleFromActivationModal = async (sample, {onProgress} = {}) => {
        const sampleId = String(sample?.id || "").trim();
        trackSessionEvent(`clicked_activation_modal_try_sample_${sampleId || "unknown"}`);

        const prepared = await prepareActivationSampleProject(sample, {
            onProgress,
            retryOnFailure: true,
        });

        await openPreparedActivationEditor({
            prepared,
            onProgress,
            reportInitialOnboardingProgress: Boolean(activationModalAutoAction),
        });
    };

    const handleUseOwnRecordingFromActivationModal = () => {
        trackSessionEvent("clicked_activation_modal_use_own_recording");
        handleCloseTrialModal();
    };

    const handleDismissTrialBanner = () => {
        if (!userId) {
            setTrialBannerDismissed(true);
            return;
        }
        const key = `librettoTrialBannerDismissed:${userId}`;
        sessionStorage.setItem(key, "true");
        setTrialBannerDismissed(true);
    };

    const buildCheckoutReturnPaths = () => {
        const currentUrl = new URL(window.location.href);
        const successUrl = new URL(currentUrl.href);
        successUrl.searchParams.set("checkout", "success");
        successUrl.searchParams.set("settings", "plan");
        const cancelUrl = new URL(currentUrl.href);
        cancelUrl.searchParams.set("checkout", "canceled");
        cancelUrl.searchParams.set("settings", "plan");
        const successPath = `${successUrl.pathname}${successUrl.search}${successUrl.search ? "&" : "?"}session_id={CHECKOUT_SESSION_ID}`;
        return {
            successPath,
            cancelPath: `${cancelUrl.pathname}${cancelUrl.search}`,
        };
    };

    const handleAddPaymentMethodClick = async () => {
        if (isCheckoutStarting) return;
        setIsCheckoutStarting(true);
        void markTrialModalSeen();
        hideTrialModal();
        try {
            const {successPath, cancelPath} = buildCheckoutReturnPaths();
            const response = await fetchContext.authAxios.get('/checkout', {
                headers: {
                    Authorization: `Bearer ${authContext.getToken()}`,
                },
                params: {
                    successPath,
                    cancelPath,
                },
            });
            const checkoutUrl = response.data?.url || response.data?.Url;
            if (checkoutUrl) {
                window.location.assign(checkoutUrl);
                return;
            }
            const sessionId = response.data?.sessionId;
            const stripe = await StripePromise;
            if (!stripe || !sessionId) {
                setIsCheckoutStarting(false);
                return;
            }
            const result = await stripe.redirectToCheckout({sessionId});
            if (result.error) {
                console.error(result.error);
            }
        } catch (error) {
            console.error("Error creating checkout session:", error);
            setIsCheckoutStarting(false);
        }
    };

    const handleSortButtonClick = () => {
        const newSortNewest = !sortNewest;
        setSortNewest(newSortNewest);
        sessionStorage.setItem(kLibrettoSortNewest, newSortNewest.toString());
    };

    const handleGridViewButtonClick = () => {
        const newShowAsGrids = !showAsGrids;
        setShowAsGrids(newShowAsGrids);
        sessionStorage.setItem(kLibrettoGridView, newShowAsGrids.toString());
    }

    // Sort projects by date based on sortNewest
    useEffect(() => {
        const sorted = projects
            .filter((project) => String(project?.activationSampleStatus || "").trim() !== "prewarmed")
            .sort((a, b) => {
            const aTime = normalizeTimestampToMillis(a.lastViewed) || 0;
            const bTime = normalizeTimestampToMillis(b.lastViewed) || 0;
            return sortNewest ? bTime - aTime : aTime - bTime;
        });
        setSortedProjects(sorted);
    }, [sortNewest, projects]);

    // Reset currentProjectId if it no longer exists in projects list
    useEffect(() => {
        if (currentProjectId && !projects.some(p => p.projectId === currentProjectId)) {
            setCurrentProjectId(null);
            sessionStorage.removeItem(kLibrettoCurrentProjectId);
        }
    }, [projects, currentProjectId]);

    // Sort the current project assets by date based on sortNewest
    useEffect(() => {
        const sorted = [...currentProjectAssets].sort((a, b) => {
            const aTime = normalizeTimestampToMillis(a.createTime) || 0;
            const bTime = normalizeTimestampToMillis(b.createTime) || 0;
            return sortNewest ? bTime - aTime : aTime - bTime;
        });
        setSortedAssets(sorted);
    }, [sortNewest, currentProjectAssets]);

    const pageStyle = {
        height: "100vh",
        width: "100vw",
        backgroundColor: "var(--app-bg-canvas)",
        display: "flex",
        flexDirection: "row",
    };

    const isXl = useMediaQuery(theme.breakpoints.up('xl'));
    const isLg = useMediaQuery(theme.breakpoints.up('lg'));
    const mainContentMaxWidth = isXl ? 1320 : isLg ? 1120 : 1020;

    const sidebarWidthExpanded = isXl ? "280px" : isLg ? "250px" : "250px";
    const sidebarWidthCollapsed = "72px";
    const sidebarWidth = sidebarCollapsed ? sidebarWidthCollapsed : sidebarWidthExpanded;

    const sideBarStyle = (isMobile) => {
        return {
            width: sidebarWidth,
            height: "100vh",
            backgroundColor: "var(--app-bg-surface)",
            display: isMobile ? "none" : "flex",
            flexDirection: "column",
            padding: sidebarCollapsed ? "8px 8px 24px 8px" : "8px 12px 24px 12px",
            alignItems: sidebarCollapsed ? "center" : "flex-start",
            transition: "width 0.2s ease, padding 0.2s ease",
            borderRight: "1px solid var(--app-border-subtle)",
        }
    }

    const demoIconNode = <AdsClickIcon sx={{color: "var(--app-text-muted)"}}/>;

    // CSS class name for sidebar hover detection (used when collapsed)
    const sidebarClassName = sidebarCollapsed ? "sidebar-collapsed" : "sidebar-expanded";

    const navigateToProject = ({projectId}) => {
        navigate("/editor/" + projectId);
    }

    const sidebarHeaderStyle = {
        display: "flex",
        padding: "0px 12px",
        justifyContent: "space-between",
        alignItems: "center",
        alignSelf: "stretch",
        flexDirection: "row",
    }

    const sidebarHeaderTextStyle = {
        fontFamily: "Inter",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "24px",
        letterSpacing: "0.18px",
    }

    const newProjectIconStyle = (disabled) => {
        return ({
                display: "flex",
                padding: "12px",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                borderRadius: "100px",
                backgroundColor: newProjectIconBackground,
                cursor: disabled ? "not-allowed" : "pointer",
                // ON hover
                '&:hover': {
                    backgroundColor: disabled
                        ? newProjectIconBackground
                        : newProjectIconHoverBackground,
                },
            }
        )
    }

    const dividerStyle = {
        display: "flex",
        padding: "1px 0px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "10px",
        alignSelf: "stretch",
        marginTop: "16px",
        marginBottom: "16px",
    }

    const projectTitleStyle = {
        display: 'flex',
        padding: '16px 12px',
        alignItems: 'center',
        gap: '12px',
        alignSelf: 'stretch',
        borderRadius: '8px',
        cursor: 'pointer',
        // ON hover
        '&:hover': {
            background: "rgba(43, 107, 253, 0.10)",
        },
    }

    const selectedProjectStyle = {
        ...projectTitleStyle,
        background: selectedNavBackground,
    }

    const actualDividerStyle = {
        height: "1px",
        alignSelf: "stretch",
        backgroundColor: "var(--app-border-subtle)",
    }

    const effectiveStyle = (index) => {
        if (projects[index].projectId === currentProjectId) {
            return selectedProjectStyle;
        } else {
            return projectTitleStyle;
        }
    }

    const projectTitleTextStyle = {
        color: "var(--app-text-primary)",
        fontFamily: "Inter",
        fontSize: "15px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.16px",
    }

    const selectedProjectTitleTextStyle = {
        ...projectTitleTextStyle,
        color: "#2B6BFD",
    }

    const effectiveTextStyle = (index) => {
        if (projects[index].projectId === currentProjectId) {
            return selectedProjectTitleTextStyle;
        } else {
            return projectTitleTextStyle;
        }
    }

    const upgradeBoxStyle = {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px 12px",
        borderRadius: "14px",
        cursor: "pointer",
        background: "linear-gradient(135deg, #2B6BFD 0%, #111111 90%)",
        boxShadow: "0 8px 22px rgba(0, 0, 0, 0.18)",
    };

    const lightningIconStyle = {
        fontSize: "18px",
        color: "#ffffff",
    };

    const upgradeInfoStyle = {
        flexShrink: 1,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        color: "#ffffff",
    };

    const upgradeTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "20px",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        width: "100%",
    };

    const upgradeSubtextStyle = {
        fontFamily: "Inter",
        fontSize: "12px",
        fontWeight: 400,
        opacity: 0.9,
    };


    const GetInitial = (name) => {
        return name ? name.charAt(0).toUpperCase() : '?';
    }

    const resolvedProfileImage = authContext.getUserPhotoUrl();
    const profileTooltipText = [authContext.getUserDisplayName(), authContext.getUserEmail()]
        .filter(Boolean)
        .join(" - ");

    const topRightProfileRowStyle = {
        position: "fixed",
        top: 15,
        right: 20,
        zIndex: 1100,
    };

    const topProfileButtonStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "34px",
        height: "34px",
        borderRadius: "50%",
        backgroundColor: "var(--app-bg-surface)",
        border: "1px solid var(--app-border-subtle)",
        cursor: "pointer",
        transition:
            "background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
        boxShadow: "0 0 0 rgba(0, 0, 0, 0)",
        "&:hover": {
            backgroundColor: "var(--app-bg-subtle)",
            borderColor: "var(--app-border-muted)",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.04)",
        },
    };

    const topProfileInitialStyle = {
        width: "30px",
        height: "30px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: topProfileInitialBackground,
        color: "#ffffff",
        fontWeight: 600,
        fontSize: 13,
        lineHeight: 1,
        textTransform: "uppercase",
        flexShrink: 0,
    };

    const topProfileImageStyle = {
        width: "30px",
        height: "30px",
        borderRadius: "50%",
        objectFit: "cover",
        flexShrink: 0,
    };

    const {openDialog, ConfirmDialogComponent} = useConfirmDialog({confirmText: 'Delete', cancelText: 'Cancel'});

    const {DeleteProject} = useAssetStore();

    const handleDeleteProjectClick = (projectId) => {
        openDialog({
            title: 'Delete Project',
            message: 'This project and all its assets will be permanently deleted.',
            onConfirm: async () => {
                await DeleteProject({projectId});
            },
        });
    };

    useEffect(() => {
        if (!userId || !currentWorkspaceId) {
            return;
        }

        const q = query(
            collection(db, kProjectsCollectionName),
            where(WorkspaceId, "==", currentWorkspaceId),
            where(ProjectDeleted, "==", false)
        );
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const newProjects = [];
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    // Only include projects created on or after V2 release (2026)
                    const createTime = normalizeTimestampToMillis(data.createTime);
                    if (createTime && createTime >= V2_RELEASE_TIMESTAMP) {
                        newProjects.push(data);
                    }
                });
                if (newProjects.length > 0) {
                    setProjects(newProjects);
                } else {
                    // Handle case when all projects are deleted or all are legacy
                    setProjects([]);
                }
            },
            (error) => {
                console.error('[AgenticHome] projects snapshot error', error);
            });

        return () => unsubscribe();
    }, [userId, currentWorkspaceId]);

    // Load the assets that belong to the current project.
    useEffect(() => {
        if (currentProjectId) {
            const q = query(
                collection(db, kAssetsCollectionName),
                where(AssetDeleted, "==", false),
                where(AssetProjectId, "==", currentProjectId),
                ...(currentWorkspaceId ? [where(WorkspaceId, "==", currentWorkspaceId)] : []),
            );
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                    const newAssets = [];
                    querySnapshot.forEach((doc) => {
                        // EXCLUDED_ASSETS
                        if (doc.data()[AssetType] !== "SOUNDBOARD_AUDIO" && doc.data()[AssetType] !== "BRAND_LOGO" && doc.data()[AssetType] !== "IMAGE_UPLOAD") {
                            newAssets.push(doc.data());
                        }
                    });
                    setCurrentProjectAssets(newAssets);
                },
                (error) => {
                    console.error('[AgenticHome] assets snapshot error', error);
                });

            return () => unsubscribe();
        } else {
            setCurrentProjectAssets([]);
        }
    }, [currentProjectId, currentWorkspaceId]);

// Refreshes urls for assets and tracks of the project
    useEffect(() => {
        if (currentProjectId === null) {
            return;
        }

        const LoadProjectUrls = async () => {
            try {
                await fetchContext.authAxios.get(`/project/${currentProjectId}`, {
                    headers: {
                        Authorization: `Bearer ${authContext.getToken()}`,
                    }
                });
            } catch (error) {
                console.error("Error getting track urls:", error);
            }
        }

        LoadProjectUrls();
        return () => {
        };
    }, [currentProjectId]);

    const handleThreeDotsButtonClick = (event) => {

        if (isMobile) {
            event.preventDefault();
            setSwitchToComputerFormOpen(true);
            return;
        }

        if (threeDotsMenuOpen) {
            setThreeDotsMenuOpen(false);
            return;
        }

        // Get the top and right position of the button
        const top = event.currentTarget.getBoundingClientRect().top;
        const right = event.currentTarget.getBoundingClientRect().right;
        // Set the position of the context menu
        setThreeDotsMenuTop(top);
        setThreeDotsMenuRight(right);
        setThreeDotsMenuOpen(true);
    }

    const handleRecordingTypesButtonClick = (event) => {
        if (isMobile) {
            event.preventDefault();
            setSwitchToComputerFormOpen(true);
            return;
        }

        if (recordingTypesMenuOpen) {
            setRecordingTypesMenuOpen(false);
            return;
        }

        setRecordingTypesMenuOpen(true);
    }

    const handleRenameProjectClick = (e) => {
        if (isMobile) {
            e.preventDefault();
            setSwitchToComputerFormOpen(true);
            return;
        }

        e.stopPropagation();
        setIsEditingTitle(true);
        setThreeDotsMenuOpen(false);
    }

    const updateTitle = async ({projectId, title}) => {
        // Update Firestore
        const entityRef = doc(db, kProjectsCollectionName, projectId);
        try {
            await updateDoc(entityRef, {name: title, [ProjectNameSource]: "user"});
            console.log('Title updated successfully');
        } catch (error) {
            console.error('Error updating title: ', error);
        }
    };

    const handleUpdateTitleClick = async () => {
        await updateTitle({projectId: titleCreationProjectId, title: newProjectTitle});
        setTitleCreationCardOpen(false);
        setNewProjectTitle('Untitled Project');
        sessionStorage.setItem(kLibrettoCurrentProjectId, titleCreationProjectId);
        setCurrentProjectId(titleCreationProjectId);
        setTitleCreationProjectId(null);
    }

    const handleKeyDownForTitle = async (e) => {
        if (e.key === 'Enter') {
            await handleUpdateTitleClick();
        }
    }

    const handleCloseNewProjectCard = () => {
        setTitleCreationCardOpen(false);
        setNewProjectTitle('Untitled Project');
    }

    const handleProfileButtonClick = (e) => {
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();
        setProfileMenuTop(rect.bottom + 8);
        setProfileMenuRight(window.innerWidth - rect.right);
        setProfileAvatarMenuOpen(!profileAvatarMenuOpen);
    }

    const openSettingsModal = (tab = "profile") => {
        setSettingsActiveTab(tab);
        setSettingsModalOpen(true);
    };

    const closeSettingsModal = () => {
        setSettingsModalOpen(false);
    };

    const logoutUser = async () => {
        await authContext.logout()
    }

    const handleShareButtonClick = (e) => {
        if (isMobile) {
            e.preventDefault();
            setSwitchToComputerFormOpen(true);
            return;
        }

        // e is a click on a button. Get the right position of the button
        setShowShareProjectCard(!showShareProjectCard);
    }

    const handleRecordWithOthersClick = (e) => {
        if (isFreePlan) return openSettingsModal("plan");
        trackSessionEvent("entered_studio_lobby");
        navigate(`/studio`);
    }

    const handleRecordAudioOnlyClick = async (e) => {
        if (isFreePlan) return openSettingsModal("plan");
        trackSessionEvent("solo_audio_studio_opened");
        // If we are already on the
        const projectId = await CreateProject();
        navigate("/editor/" + projectId + "?mode=recording&type=audio");
    }


    const handleRecordScreenClick = async (e) => {
        if (isFreePlan) return openSettingsModal("plan");
        trackSessionEvent("solo_screen_studio_opened");
        // If we are already on the
        const projectId = await CreateProject();
        navigate("/editor/" + projectId + "?mode=recording&type=screen");
    }

    const handleRecordCameraClick = async (e) => {
        if (isFreePlan) return openSettingsModal("plan");
        trackSessionEvent("solo_video_studio_opened");
        const projectId = await CreateProject();
        navigate("/editor/" + projectId + "?mode=recording&type=video");
    }

    const navigateToUpgrade = () => {
        mixpanel.track('Upgrade attempt', {
            'userId': authContext.getUserId(),
            'email': authContext.getUserEmail(),
        });
        navigate("/dashboard?settings=plan")
    }

    const handleCreateProjectClick = async () => {
        if (isFreePlan) {
            navigate("/editor");
            return;
        }
        const projectId = await CreateProject();
        navigateToProject({projectId});
    }

    useEffect(() => {
        if (userId !== '') {
            const q = query(collection(db, kRoomStateCollectionName), where(RoomUserId, "==", userId));
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const newRoomState = [];
                querySnapshot.forEach((doc) => {
                    newRoomState.push(doc.data());
                });
                if (newRoomState.length > 0) {
                    setInvitedEmails(newRoomState[0].hasOwnProperty("invitedEmails") ? newRoomState[0].invitedEmails : []);
                    setRoomName(newRoomState[0].hasOwnProperty("roomName") ? newRoomState[0].roomName : "");
                }
            });
            return () => unsubscribe();
        } else {
        }
    }, [userId]);

    useEffect(() => {
        if (!userId) {
            return;
        }

        const userRef = doc(db, kLibrettoUserCollectionName, userId);
        const unsubscribe = onSnapshot(
            userRef,
            (docSnap) => {
                if (docSnap.exists()) {
                    const docData = docSnap.data() || {};
                    setUserFriendlyRoomName(typeof docData.userFriendlyRoomName === "string" ? docData.userFriendlyRoomName : "");
                    setUserBillingState({
                        subscriptionStatus: docData.subscriptionStatus ?? null,
                        trialEndDate: docData.trialEndDate ?? null,
                        stripeHasPaymentMethod: docData.stripeHasPaymentMethod ?? false,
                        hasSeenTrialModal: docData.hasSeenTrialModal ?? false,
                        hasCompletedInitialOnboarding: docData.hasCompletedInitialOnboarding === true,
                        onboardingRole: typeof docData.onboardingRole === "string" ? docData.onboardingRole : "",
                        onboardingFirstThingToSee:
                            typeof docData.onboardingFirstThingToSee === "string"
                                ? docData.onboardingFirstThingToSee
                                : "",
                        loaded: true,
                    });
                } else {
                    setUserBillingState((prev) => ({...prev, loaded: true}));
                }
            },
            (error) => {
                console.error("[AgenticHome] user snapshot error", error);
                setUserBillingState((prev) => ({...prev, loaded: true}));
            }
        );
        return () => unsubscribe();
    }, [userId]);

    const headerTextStyle = {
        fontFamily: "Inter",
        fontSize: 32,
        fontWeight: 500,
        lineHeight: "40px",
        letterSpacing: 0,
    };

    const sectionTitleStyle = {
        fontFamily: "Inter",
        fontSize: 20,
        fontWeight: 500,
        lineHeight: "24px",
    };

    const trialBannerStyle = {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "10px 14px",
        borderRadius: "12px",
        border: `1px solid ${trialBannerBorderColor}`,
        backgroundColor: trialBannerBackground,
        boxShadow: isDarkMode
            ? `0px 10px 24px ${alpha(theme.palette.primary.main, 0.2)}`
            : `0px 8px 20px ${alpha(theme.palette.primary.main, 0.12)}`,
        marginBottom: "14px",
        flexWrap: "wrap",
        maxWidth: "calc(100% - 60px)",
    };

    const trialBannerTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 600,
        color: "var(--app-text-primary)",
        lineHeight: "20px",
        flex: 1,
        minWidth: "200px",
    };

    const trialBannerActionsStyle = {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginLeft: "auto",
    };

    const trialBannerLinkStyle = {
        textTransform: "none",
        fontFamily: "Inter",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "20px",
        color: theme.palette.primary.main,
        padding: "4px 8px",
        borderRadius: "999px",
        minWidth: "auto",
        "&:hover": {
            backgroundColor: alpha(theme.palette.primary.main, isDarkMode ? 0.24 : 0.12),
            textDecoration: "none",
        },
        "&.Mui-disabled": {
            color: "var(--app-text-subtle)",
        },
    };

    const handleHomeSidebarButtonClick = () => {
        setCurrentView(ViewState.HOME);
        setCurrentProjectId(null);
    }

    const handleWorkspaceSelect = (workspaceId) => {
        if (!workspaceId || workspaceId === currentWorkspaceId) return;
        setCurrentView(ViewState.HOME);
        setProjects([]);
        setCurrentProjectId(null);
        setCurrentProjectAssets([]);
        setCurrentProjectTitle("");
        sessionStorage.removeItem(kLibrettoCurrentProjectId);
        authContext.setCurrentWorkspaceId(workspaceId);
    };

    const handleProjectsSidebarButtonClick = () => {
        setCurrentView(ViewState.PROJECTS);
        setCurrentProjectId(null);
    }

    const handleProjectCardClick = (project) => {
        if (isMobile) {
            setSwitchToComputerFormOpen(true);
            return;
        }
        // if (project.projectType === LibrettoProjectTypes.ProjectTypeEditor || project.projectType === LibrettoProjectTypes.ProjectTypeCaptions) {
        //
        //     console.log("Navigating to /agent/ ", project.projectId);
        //     navigate(`/v2/${project.projectId}`);
        //     return;
        // }

        navigate(`/editor/${project.projectId}`);

        // console.log("Project type is: ", project.projectType);
        //
        // setCurrentView(ViewState.SINGLE_PROJECT);
        // setCurrentProjectId(project.projectId);
    }

    const handleViewAllProjectsButtonClick = () => {
        setCurrentView(ViewState.PROJECTS);
        setCurrentProjectId(null);
    }

    const toggleRecordSomethingMenu = (buttonRef) => {
        if (!buttonRef.current) {
            return;
        }

        const isSameAnchor = recordSomethingMenuAnchorRef.current === buttonRef.current;
        if (recordSomethingMenuOpen && isSameAnchor) {
            setRecordSomethingMenuOpen(false);
            return;
        }

        const rect = buttonRef.current.getBoundingClientRect();
        const menuWidth = 260;
        const horizontalPadding = 8;
        const maxLeft = window.scrollX + window.innerWidth - menuWidth - horizontalPadding;
        const clampedLeft = Math.max(
            window.scrollX + horizontalPadding,
            Math.min(rect.left + window.scrollX, maxLeft)
        );

        setRecordSomethingMenuPosition({
            top: rect.bottom + window.scrollY + 4,
            left: clampedLeft
        });
        recordSomethingMenuAnchorRef.current = buttonRef.current;
        setRecordSomethingMenuOpen(true);
    }

    const handleRecordSomethingButtonClick = () => {
        trackSessionEvent("clicked_record_something");
        toggleRecordSomethingMenu(recordSomethingButtonRef);
    }

    const handleHeaderRecordSomethingButtonClick = () => {
        if (isFreePlan) return navigate("/editor");
        toggleRecordSomethingMenu(headerRecordButtonRef);
    }

    const handleEditByTranscriptSelect = () => {
        if (isFreePlan) return navigate("/editor");
        trackSessionEvent("clicked_edit_by_transcript");
        setUploadCardWorkflowType(homeWorkflowDialogTypes.EDIT_BY_TRANSCRIPT);
        setShowUploadCard(true);
    }

    const handleCreateSocialClipsSelect = () => {
        trackSessionEvent("clicked_upload_and_edit");
        setUploadCardWorkflowType(homeWorkflowDialogTypes.CREATE_SOCIAL_CLIPS);
        setShowUploadCard(true);
    }

    const handleMakePodcastSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.MAKE_PODCAST);
        setShowUploadCard(true);
    }

    const handleTranscribeFileSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.TRANSCRIBE_FILE);
        setShowUploadCard(true);
    }

    const handleAddCaptionsSelect = () => {
        trackSessionEvent("clicked_add_captions");
        setUploadCardWorkflowType(homeWorkflowDialogTypes.ADD_CAPTIONS);
        setShowUploadCard(true);
    }

    const handleEditForClaritySelect = () => {
        if (isFreePlan) return navigate("/editor");
        trackSessionEvent("clicked_edit_for_clarity");
        setUploadCardWorkflowType(homeWorkflowDialogTypes.CLEAN_UP_RECORDING);
        setShowUploadCard(true);
    }

    const getCompositionSortValue = (composition = {}) => {
        const updatedAt = Number(
            composition.updatedAt ?? composition.updateTime ?? composition.updated_at ?? 0
        );
        if (Number.isFinite(updatedAt) && updatedAt > 0) return updatedAt;

        const createdAt = Number(
            composition.createdAt ?? composition.createTime ?? composition.created_at ?? 0
        );
        if (Number.isFinite(createdAt) && createdAt > 0) return createdAt;

        return 0;
    };

    const resolveCompositionIdForProject = async (projectId) => {
        if (!projectId) return null;

        try {
            const q = query(
                collection(db, kCompositionsCollectionName),
                where(CompositionProjectId, "==", projectId),
                where(CompositionDeleted, "==", false)
            );
            const snapshot = await getDocs(q);
            if (!snapshot.empty) {
                const sorted = snapshot.docs
                    .map((docSnap) => ({id: docSnap.id, data: docSnap.data()}))
                    .sort((a, b) => getCompositionSortValue(b.data) - getCompositionSortValue(a.data));
                const best = sorted[0];
                const bestId = String(best?.data?.compositionId || best?.id || "").trim();
                if (bestId) return bestId;
            }
        } catch (error) {
            console.warn("[AgenticHome] Failed to read compositions for Edit for Clarity", error);
        }

        try {
            const createdId = await CreateComposition({projectId});
            const resolved = String(createdId || "").trim();
            return resolved || null;
        } catch (error) {
            console.error("[AgenticHome] Failed to create composition for Edit for Clarity", error);
            return null;
        }
    };

    const handleEditForClarityEditorReady = async ({
                                                       projectId: readyProjectId,
                                                       assetId,
                                                       settings,
                                                   }) => {
        const resolvedProjectId = String(readyProjectId || "").trim();
        const resolvedAssetId = String(assetId || "").trim();
        if (!resolvedProjectId || !resolvedAssetId) return;
        if (editForClarityNavigatingRef.current) return;

        editForClarityNavigatingRef.current = true;
        try {
            const compositionId = await resolveCompositionIdForProject(resolvedProjectId);
            if (!compositionId) {
                throw new Error("Missing composition id for Edit for Clarity navigation");
            }

            const params = new URLSearchParams();
            params.set("clarityAutoinsert", "1");
            params.set("clarityAssetId", resolvedAssetId);
            params.set("clarityCompositionId", compositionId);
            params.set("clarityIntensity", String(settings?.intensity || "medium"));

            setShowUploadCard(false);
            navigate(`/editor/${resolvedProjectId}?${params.toString()}`);
        } catch (error) {
            console.error("[AgenticHome] Failed to open editor for Edit for Clarity", error);
            editForClarityNavigatingRef.current = false;
            throw error;
        }
    };

    const handleUploadAndEditInitiated = async ({
                                                     projectId: initiatedProjectId,
                                                     assetId: initiatedAssetId,
                                                     workflowHint = "",
                                                 }) => {
        const resolvedProjectId = String(initiatedProjectId || "").trim();
        const resolvedAssetId = String(initiatedAssetId || "").trim();
        const resolvedWorkflowHint = String(workflowHint || "").trim();
        const shouldOpenFilesSidebar = resolvedWorkflowHint !== "create_social_clips";
        if (!resolvedProjectId || !resolvedAssetId) return;
        if (uploadAndEditNavigatingRef.current) return;

        uploadAndEditNavigatingRef.current = true;
        try {
            const compositionId = await resolveCompositionIdForProject(resolvedProjectId);
            if (!compositionId) {
                throw new Error("Missing composition id for upload-and-edit navigation");
            }

            const params = new URLSearchParams();
            if (shouldOpenFilesSidebar) {
                params.set("openProjectSidebarFiles", "1");
            }
            params.set("uploadAutoinsert", "1");
            params.set("uploadAssetId", resolvedAssetId);
            params.set("uploadCompositionId", compositionId);
            if (resolvedWorkflowHint) {
                params.set("uploadWorkflowHint", resolvedWorkflowHint);
            }

            setShowUploadCard(false);
            navigate(`/editor/${resolvedProjectId}?${params.toString()}`);
        } catch (error) {
            console.error("[AgenticHome] Failed to open editor for upload-and-edit", error);
            uploadAndEditNavigatingRef.current = false;
        }
    };

    const handleEnhanceAudioUploadInitiated = async ({
                                                         projectId: initiatedProjectId,
                                                         assetId: initiatedAssetId,
                                                     }) => {
        const resolvedProjectId = String(initiatedProjectId || "").trim();
        const resolvedAssetId = String(initiatedAssetId || "").trim();
        if (!resolvedProjectId || !resolvedAssetId) return;
        if (enhanceAudioNavigatingRef.current) return;

        enhanceAudioNavigatingRef.current = true;
        try {
            const compositionId = await resolveCompositionIdForProject(resolvedProjectId);
            if (!compositionId) {
                throw new Error("Missing composition id for enhance-audio navigation");
            }

            const params = new URLSearchParams();
            params.set("enhanceAudioAutoinsert", "1");
            params.set("enhanceAudioAssetId", resolvedAssetId);
            params.set("enhanceAudioCompositionId", compositionId);

            setShowUploadCard(false);
            navigate(`/editor/${resolvedProjectId}?${params.toString()}`);
        } catch (error) {
            console.error("[AgenticHome] Failed to open editor for enhance-audio upload", error);
            enhanceAudioNavigatingRef.current = false;
        }
    };

    const handleAddCaptionsUploadInitiated = async ({
                                                        projectId: initiatedProjectId,
                                                        assetId: initiatedAssetId,
                                                    }) => {
        const resolvedProjectId = String(initiatedProjectId || "").trim();
        const resolvedAssetId = String(initiatedAssetId || "").trim();
        if (!resolvedProjectId || !resolvedAssetId) return;
        if (addCaptionsNavigatingRef.current) return;

        addCaptionsNavigatingRef.current = true;
        try {
            const compositionId = await resolveCompositionIdForProject(resolvedProjectId);
            if (!compositionId) {
                throw new Error("Missing composition id for add-captions navigation");
            }

            const params = new URLSearchParams();
            params.set("captionsAutoinsert", "1");
            params.set("captionsAssetId", resolvedAssetId);
            params.set("captionsCompositionId", compositionId);

            setShowUploadCard(false);
            navigate(`/editor/${resolvedProjectId}?${params.toString()}`);
        } catch (error) {
            console.error("[AgenticHome] Failed to open editor for add-captions upload", error);
            addCaptionsNavigatingRef.current = false;
        }
    };

    const handleMultiSpeakerUploadInitiated = async ({
                                                         projectId: initiatedProjectId,
                                                         assetIds: initiatedAssetIds,
                                                     }) => {
        const resolvedProjectId = String(initiatedProjectId || "").trim();
        const resolvedAssetIds = Array.isArray(initiatedAssetIds)
            ? initiatedAssetIds.map((assetId) => String(assetId || "").trim()).filter(Boolean)
            : [];
        if (!resolvedProjectId) return;
        if (resolvedAssetIds.length < 2) return;
        if (multiSpeakerNavigatingRef.current) return;

        multiSpeakerNavigatingRef.current = true;
        try {
            const compositionId = await resolveCompositionIdForProject(resolvedProjectId);
            if (!compositionId) {
                throw new Error("Missing composition id for multi-speaker navigation");
            }

            const params = new URLSearchParams();
            params.set("multiSpeakerAutocreate", "1");
            params.set("multiSpeakerAssetIds", resolvedAssetIds.join(","));
            params.set("multiSpeakerCompositionId", compositionId);

            setShowUploadCard(false);
            navigate(`/editor/${resolvedProjectId}?${params.toString()}`);
        } catch (error) {
            console.error("[AgenticHome] Failed to open editor for multi-speaker upload", error);
            multiSpeakerNavigatingRef.current = false;
        }
    };

    const handleCleanUpAudioSelect = () => {
        if (isFreePlan) return navigate("/editor");
        trackSessionEvent("clicked_enhance_audio");
        setUploadCardWorkflowType(homeWorkflowDialogTypes.ENHANCE_AUDIO);
        setShowUploadCard(true);
    }

    const handleScheduleRecordingSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.SCHEDULE_RECORDING);
        setShowUploadCard(true);
    }

    const handleTranslateAndDubSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.TRANSLATE_AND_DUB);
        setShowUploadCard(true);
    }

    const handleEditMultiSpeakerSelect = () => {
        trackSessionEvent("clicked_edit_multi_speaker");
        setUploadCardWorkflowType(homeWorkflowDialogTypes.EDIT_MULTI_SPEAKER);
        setShowUploadCard(true);
    }

    const handleHomeAssistantAction = async (action) => {
        if (isFreePlan) {
            setAssistantDrawerOpen(false);
            openSettingsModal("plan");
            return;
        }
        if (action === "record_with_others" && isOffline) {
            setAssistantActionError("Recording with others is unavailable while you're offline.");
            trackSessionEvent("assistant_home_action_unavailable");
            return;
        }

        const actions = {
            edit_by_transcript: handleEditByTranscriptSelect,
            clean_up_recording: handleEditForClaritySelect,
            enhance_audio: handleCleanUpAudioSelect,
            edit_multi_speaker: handleEditMultiSpeakerSelect,
            add_captions: handleAddCaptionsSelect,
            create_social_clips: handleCreateSocialClipsSelect,
            record_camera: handleRecordCameraClick,
            record_screen: handleRecordScreenClick,
            record_audio: handleRecordAudioOnlyClick,
            record_with_others: handleRecordWithOthersClick,
            new_project: handleCreateProjectClick,
        };
        const runAction = actions[action];
        if (!runAction) {
            console.warn("[AgenticHome] Ignoring unsupported assistant action", action);
            setAssistantActionError("I couldn't start that. Please describe what you want another way.");
            trackSessionEvent("assistant_home_action_unknown");
            return;
        }

        setAssistantActionError(null);
        setAssistantDrawerOpen(false);
        trackSessionEvent(`assistant_home_action_${action}`);
        try {
            await runAction();
        } catch (error) {
            console.error("[AgenticHome] Assistant action failed", action, error);
            setAssistantActionError("I couldn't start that. Please try again.");
            setAssistantDrawerOpen(true);
            trackSessionEvent("assistant_home_action_failed");
        }
    };

    const {
        messages: assistantMessages,
        sendMessage: sendAssistantMessage,
        isSending: isAssistantSending,
        error: assistantRequestError,
    } = useEditorAssistant({
        authAxios: fetchContext?.authAxios,
        getFreshToken: authContext?.getFreshToken,
        surface: "home",
        onAction: handleHomeAssistantAction,
    });

    const handleSendAssistantMessage = (message) => {
        setAssistantActionError(null);
        trackSessionEvent("assistant_home_message_sent");
        return sendAssistantMessage(message);
    };

    const ProjectsViewAtHome = () => {
        return (
            <Box sx={{mt: 4}}>
                <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2}}>
                    <Box sx={sectionTitleStyle}>Projects</Box>
                    <Box sx={{display: "flex", gap: 1}}>
                        {/*<SortButton onClick={handleSortButtonClick} sortNewest={sortNewest} iconOnly={false}/>*/}
                        <ChangeViewButton isGridView={showAsGrids} onClick={handleGridViewButtonClick}/>
                        <NewProjectButton onClick={handleCreateProjectClick}/>
                    </Box>
                </Box>
                <ProjectsView
                    projects={sortedProjects}
                    showAsGrids={showAsGrids}
                    deleteProject={handleDeleteProjectClick}
                    setSwitchToComputerFormOpen={setSwitchToComputerFormOpen}
                    isMobile={isMobile}
                    handleProjectCardClick={handleProjectCardClick}
                />
                <Dialog
                    open={titleCreationCardOpen}
                    onClose={handleCloseNewProjectCard}
                    aria-labelledby="form-dialog-title"
                >
                    <NewProjectCard setNewProjectTitle={setNewProjectTitle} newProjectTitle={newProjectTitle}
                                    onKeyDown={handleKeyDownForTitle} onClose={handleCloseNewProjectCard}
                                    onClick={handleUpdateTitleClick}/>
                </Dialog>
            </Box>
        )
    }

    const HomeViewAtHome = () => {
        return (
            <Box sx={{display: "flex", flexDirection: "column", gap: 3}}>
                {/* Top bar: Record + New Project */}
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    justifyContent: "flex-end",
                    flexWrap: "wrap",
                }}>
                    <Box ref={headerRecordButtonRef} sx={{display: "flex", width: {xs: "140px", sm: "120px"}}}>
                        <SelectableCard
                            icon={<RadioButtonCheckedOutlined sx={{color: "#FF3B30", fontSize: 20}}/>}
                            label="Record"
                            onClick={handleHeaderRecordSomethingButtonClick}
                            selected={false}
                            disabled={false}
                            centered={true}
                            large={true}
                            ref={null}
                        />
                    </Box>
                    <NewProjectButton onClick={handleCreateProjectClick}/>
                </Box>

                {/* Record menu (anchored to whichever ref triggered it) */}
                {recordSomethingMenuOpen && (
                    <RecordSomethingMenu
                        setOpen={setRecordSomethingMenuOpen}
                        handleRecordScreenClick={handleRecordScreenClick}
                        handleRecordCameraClick={handleRecordCameraClick}
                        top={recordSomethingMenuPosition.top}
                        handleRecordAudioOnlyClick={handleRecordAudioOnlyClick}
                        left={recordSomethingMenuPosition.left}
                        handleRecordWithOthersClick={handleRecordWithOthersClick}
                        disableRecordWithOthers={isOffline}
                    />
                )}

                {/* ── Centered hero area with distinct background ── */}
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    px: {xs: 3, md: 5},
                    py: {xs: 4, md: 5},
                    borderRadius: "20px",
                    backgroundColor: "var(--app-bg-surface)",
                    border: "1px solid var(--app-border-subtle)",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
                }}>
                    <Box sx={{textAlign: "center", mb: 3.5}}>
                        <Box sx={{...headerTextStyle, textAlign: "center"}}>What do you want to do?</Box>
                        <Typography sx={{fontSize: 14, color: "var(--app-text-muted)", mt: 1}}>
                            Edit recordings faster. Just pick what you want to do.
                        </Typography>
                    </Box>

                {/* ── Workflow cards – 3×2 grid ── */}
                <Box sx={{
                    display: "grid",
                    gridTemplateColumns: {xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr"},
                    columnGap: 2,
                    rowGap: 1,
                    maxWidth: "960px",
                    width: "100%",
                }}>
                    {/* ── Row 1 ── */}

                    {/* 1 – Edit audio or video */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            '& .cleanupMicrocopy': {
                                opacity: 0,
                                transition: "opacity 160ms ease",
                            },
                            '&:hover .cleanupMicrocopy, &:focus-within .cleanupMicrocopy': {
                                opacity: 1,
                            },
                        }}
                    >
                        <SelectableCard
                            icon={<FeedOutlinedIcon sx={{color: "#5B5FC7"}}/>}
                            label="Edit audio or video"
                            onClick={handleEditByTranscriptSelect}
                            disabled={false}
                            ref={null}
                        />
                        <Typography
                            className="cleanupMicrocopy"
                            sx={{mt: 1, fontSize: 12, color: "var(--app-text-muted)", lineHeight: "18px"}}
                        >
                            Edit by transcript or directly on the timeline.
                        </Typography>
                    </Box>

                    {/* 2 – Clean up my recording */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            '& .cleanupMicrocopy': {
                                opacity: 0,
                                transition: "opacity 160ms ease",
                            },
                            '&:hover .cleanupMicrocopy, &:focus-within .cleanupMicrocopy': {
                                opacity: 1,
                            },
                        }}
                    >
                        <SelectableCard
                            icon={<AutoFixHighOutlinedIcon sx={{color: "#6B8E23"}}/>}
                            label="Clean up my recording"
                            onClick={handleEditForClaritySelect}
                            disabled={false}
                            ref={null}
                        />
                        <Typography
                            className="cleanupMicrocopy"
                            sx={{mt: 1, fontSize: 12, color: "var(--app-text-muted)", lineHeight: "18px"}}
                        >
                            Remove filler words, long pauses, and retakes automatically.
                        </Typography>
                    </Box>

                    {/* 3 – Enhance audio quality */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            '& .cleanupMicrocopy': {
                                opacity: 0,
                                transition: "opacity 160ms ease",
                            },
                            '&:hover .cleanupMicrocopy, &:focus-within .cleanupMicrocopy': {
                                opacity: 1,
                            },
                        }}
                    >
                        <SelectableCard
                            icon={<GraphicEqOutlinedIcon sx={{color: "#0EA5E9"}}/>}
                            label="Enhance audio quality"
                            onClick={handleCleanUpAudioSelect}
                            disabled={false}
                            ref={null}
                        />
                        <Typography
                            className="cleanupMicrocopy"
                            sx={{mt: 1, fontSize: 12, color: "var(--app-text-muted)", lineHeight: "18px"}}
                        >
                            Remove noise, enhance speech and level audio automatically.
                        </Typography>
                    </Box>

                    {/* ── Row 2 ── */}

                    {/* 4 – Edit multi-speaker recording */}
                    {/*<Box*/}
                    {/*    sx={{*/}
                    {/*        display: "flex",*/}
                    {/*        flexDirection: "column",*/}
                    {/*        '& .cleanupMicrocopy': {*/}
                    {/*            opacity: 0,*/}
                    {/*            transition: "opacity 160ms ease",*/}
                    {/*        },*/}
                    {/*        '&:hover .cleanupMicrocopy, &:focus-within .cleanupMicrocopy': {*/}
                    {/*            opacity: 1,*/}
                    {/*        },*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <SelectableCard*/}
                    {/*        icon={<PeopleOutlineIcon sx={{color: "#8B5CF6"}}/>}*/}
                    {/*        label="Edit multi-speaker recording"*/}
                    {/*        onClick={handleEditMultiSpeakerSelect}*/}
                    {/*        disabled={false}*/}
                    {/*        ref={null}*/}
                    {/*    />*/}
                    {/*    <Typography*/}
                    {/*        className="cleanupMicrocopy"*/}
                    {/*        sx={{mt: 1, fontSize: 12, color: "var(--app-text-muted)", lineHeight: "18px"}}*/}
                    {/*    >*/}
                    {/*        Edit separate track recordings easily as a single timeline clip and transcript.*/}
                    {/*    </Typography>*/}
                    {/*</Box>*/}

                    {/* 5 – Add captions */}
                    {/*<Box*/}
                    {/*    sx={{*/}
                    {/*        display: "flex",*/}
                    {/*        flexDirection: "column",*/}
                    {/*        '& .cleanupMicrocopy': {*/}
                    {/*            opacity: 0,*/}
                    {/*            transition: "opacity 160ms ease",*/}
                    {/*        },*/}
                    {/*        '&:hover .cleanupMicrocopy, &:focus-within .cleanupMicrocopy': {*/}
                    {/*            opacity: 1,*/}
                    {/*        },*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <SelectableCard*/}
                    {/*        icon={<ClosedCaptionOffOutlinedIcon sx={{color: "#F59E0B"}}/>}*/}
                    {/*        label="Add captions"*/}
                    {/*        onClick={handleAddCaptionsSelect}*/}
                    {/*        disabled={false}*/}
                    {/*        ref={null}*/}
                    {/*    />*/}
                    {/*    <Typography*/}
                    {/*        className="cleanupMicrocopy"*/}
                    {/*        sx={{mt: 1, fontSize: 12, color: "var(--app-text-muted)", lineHeight: "18px"}}*/}
                    {/*    >*/}
                    {/*        Apply captions by choosing from several customizable presets.*/}
                    {/*    </Typography>*/}
                    {/*</Box>*/}

                    {/* 6 – Create social clips */}
                    {/*<Box*/}
                    {/*    sx={{*/}
                    {/*        display: "flex",*/}
                    {/*        flexDirection: "column",*/}
                    {/*        '& .cleanupMicrocopy': {*/}
                    {/*            opacity: 0,*/}
                    {/*            transition: "opacity 160ms ease",*/}
                    {/*        },*/}
                    {/*        '&:hover .cleanupMicrocopy, &:focus-within .cleanupMicrocopy': {*/}
                    {/*            opacity: 1,*/}
                    {/*        },*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <SelectableCard*/}
                    {/*        icon={<CropPortraitIcon sx={{color: "#21236E"}}/>}*/}
                    {/*        label="Create social clips"*/}
                    {/*        onClick={handleCreateSocialClipsSelect}*/}
                    {/*        disabled={false}*/}
                    {/*        ref={null}*/}
                    {/*    />*/}
                    {/*    <Typography*/}
                    {/*        className="cleanupMicrocopy"*/}
                    {/*        sx={{mt: 1, fontSize: 12, color: "var(--app-text-muted)", lineHeight: "18px"}}*/}
                    {/*    >*/}
                    {/*        Turn a longer recording into short, shareable clips.*/}
                    {/*    </Typography>*/}
                    {/*</Box>*/}
                </Box>

                <Box sx={{mt: 2.5, display: "flex", justifyContent: "center"}}>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            if (isFreePlan) return navigate("/editor");
                            setAssistantActionError(null);
                            setAssistantDrawerOpen(true);
                            trackSessionEvent("home_assistant_opened");
                        }}
                        sx={{
                            width: "min(100%, 520px)",
                            px: 1.5,
                            py: 1.125,
                            justifyContent: "flex-start",
                            textTransform: "none",
                            fontFamily: "Inter",
                            color: "var(--app-text-primary)",
                            borderColor: "var(--app-border-muted)",
                            borderRadius: "12px",
                            backgroundColor: "var(--app-bg-surface)",
                            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                            transition: "border-color 150ms ease, box-shadow 150ms ease, transform 100ms ease",
                            "&:hover": {
                                color: "var(--app-text-primary)",
                                borderColor: "var(--app-text-primary)",
                                backgroundColor: "var(--app-bg-subtle)",
                                boxShadow: "0 5px 14px rgba(0, 0, 0, 0.07)",
                                transform: "translateY(-1px)",
                            },
                        }}
                    >
                        <Box sx={{
                            width: 34,
                            height: 34,
                            flex: "0 0 34px",
                            display: "grid",
                            placeItems: "center",
                            borderRadius: "9px",
                            backgroundColor: "var(--app-bg-subtle)",
                        }}>
                            <AutoAwesomeRoundedIcon sx={{fontSize: 18, color: "#F05A3C"}}/>
                        </Box>
                        <Box sx={{ml: 1.25, flex: 1, minWidth: 0, textAlign: "left"}}>
                            <Typography sx={{
                                fontFamily: "Inter",
                                fontSize: 13.5,
                                lineHeight: "19px",
                                fontWeight: 500,
                                color: "var(--app-text-primary)",
                            }}>
                                Describe what you want to do
                            </Typography>
                            <Typography sx={{
                                mt: 0.125,
                                fontFamily: "Inter",
                                fontSize: 11.5,
                                lineHeight: "17px",
                                fontWeight: 400,
                                color: "var(--app-text-muted)",
                            }}>
                                Or ask a question about editing in Libretto
                            </Typography>
                        </Box>
                        <Box component="span" sx={{
                            ml: 1,
                            px: 0.625,
                            py: 0.125,
                            borderRadius: "5px",
                            backgroundColor: "var(--app-bg-subtle)",
                            color: "var(--app-text-muted)",
                            fontSize: 9,
                            lineHeight: "13px",
                            fontWeight: 700,
                            letterSpacing: "0.06em",
                        }}>
                            AI
                        </Box>
                    </Button>
                </Box>

                </Box>{/* end centered hero area */}

                {/* Upload dialog */}
                <Dialog
                    open={showUploadCard && !isFreePlan}
                    onClose={() => setShowUploadCard(false)}
                    aria-labelledby="form-dialog-title"
                    maxWidth={"1000px"}
                >
                    <DialogContent sx={{
                        borderRadius: '30px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: "0px 0px 0px 0px",
                    }}>
                        {uploadCardWorkflowType === homeWorkflowDialogTypes.CLEAN_UP_RECORDING ? (
                            <EditForClarityWorkflow
                                onClose={() => setShowUploadCard(false)}
                                projectId={currentProjectId}
                                onEditorReady={handleEditForClarityEditorReady}
                                onUseSample={isBeforeTrial ? handleUseSampleTranscript : undefined}
                            />
                        ) : uploadCardWorkflowType === homeWorkflowDialogTypes.EDIT_BY_TRANSCRIPT ? (
                            <UploadAndEditWorkflow
                                onClose={() => setShowUploadCard(false)}
                                projectId={currentProjectId}
                                onUploadInitiated={(payload) => handleUploadAndEditInitiated({
                                    ...payload,
                                    workflowHint: "edit_by_transcript",
                                })}
                                title="Edit audio or video"
                                subtitle="Use the transcript when there’s speech, or edit directly on the timeline."
                                selectTitle="Upload audio or video"
                                accept="video/*,audio/*"
                                allowImages={false}
                                imageNotAllowedMessage="Images are not supported in Edit by transcript. Upload an audio or video file."
                                inputId="edit-by-transcript-upload"
                                onUseSample={isBeforeTrial ? handleUseSampleTranscript : undefined}
                            />
                        ) : uploadCardWorkflowType === homeWorkflowDialogTypes.CREATE_SOCIAL_CLIPS ? (
                            <UploadAndEditWorkflow
                                onClose={() => setShowUploadCard(false)}
                                projectId={currentProjectId}
                                onUploadInitiated={(payload) => handleUploadAndEditInitiated({
                                    ...payload,
                                    workflowHint: "create_social_clips",
                                })}
                                title="Create social clips"
                                subtitle="Turn a longer recording into short, shareable clips."
                                selectTitle="Upload audio or video"
                                accept="video/*,audio/*"
                                allowImages={false}
                                requireAudioStream={true}
                                missingAudioValidationMessage="This file has no audio stream. Create social clips requires speech audio."
                                imageNotAllowedMessage="Images are not supported in Create social clips. Upload an audio or video file."
                                inputId="create-social-clips-upload"
                                onUseSample={isBeforeTrial ? handleUseSampleTranscript : undefined}
                            />
                        ) : uploadCardWorkflowType === homeWorkflowDialogTypes.ENHANCE_AUDIO ? (
                            <UploadAndEditWorkflow
                                onClose={() => setShowUploadCard(false)}
                                projectId={currentProjectId}
                                onUploadInitiated={handleEnhanceAudioUploadInitiated}
                                title="Enhance audio quality"
                                subtitle="Remove background noise, enhance speech and level the audio of your recording."
                                selectTitle="Upload audio or video"
                                accept="video/*,audio/*"
                                allowImages={false}
                                requireAudioStream={true}
                                queueEnhancementOnUpload={true}
                                notifyParentOnServerInitiated={false}
                                missingAudioValidationMessage="This file has no audio stream. Audio enhancement requires audio."
                                imageNotAllowedMessage="Images are not supported in Enhance audio quality. Upload an audio or video file."
                                inputId="enhance-audio-upload"
                            />
                        ) : uploadCardWorkflowType === homeWorkflowDialogTypes.EDIT_MULTI_SPEAKER ? (
                            <EditMultiSpeakerWorkflow
                                onClose={() => setShowUploadCard(false)}
                                projectId={currentProjectId}
                                onUploadInitiated={handleMultiSpeakerUploadInitiated}
                            />
                        ) : uploadCardWorkflowType === homeWorkflowDialogTypes.ADD_CAPTIONS ? (
                            <UploadAndEditWorkflow
                                onClose={() => setShowUploadCard(false)}
                                projectId={currentProjectId}
                                onUploadInitiated={handleAddCaptionsUploadInitiated}
                                title="Add captions"
                                subtitle="Upload a file with audio and apply captions with one click."
                                selectTitle="Upload audio or video"
                                accept="video/*,audio/*"
                                allowImages={false}
                                requireAudioStream={true}
                                notifyParentOnServerInitiated={false}
                                missingAudioValidationMessage="This file has no audio stream. Captions require audio."
                                imageNotAllowedMessage="Images are not supported in Add captions. Upload an audio or video file."
                                inputId="add-captions-upload"
                            />
                        ) : (
                            <AgenticUploadContentCard
                                onClose={() => setShowUploadCard(false)}
                                projectId={currentProjectId}
                                workflowType={uploadCardWorkflowType}
                            />
                        )}
                    </DialogContent>
                </Dialog>

                {/* Recent projects section */}
                {sortedProjects.length > 0 && (
                    <Box sx={{mt: 5}}>
                        {/* Section header */}
                        <Box sx={{mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                            <Typography sx={{
                                fontFamily: '"Inter", sans-serif',
                                fontSize: 16,
                                fontWeight: 500,
                                lineHeight: '20px',
                            }}>
                                Recent projects
                            </Typography>
                            {sortedProjects.length > 5 && (
                                <Button
                                    variant="text"
                                    size="small"
                                    onClick={handleViewAllProjectsButtonClick}
                                    sx={{
                                        textTransform: 'none',
                                        fontFamily: '"Inter", sans-serif',
                                        fontSize: 12,
                                        color: 'var(--app-text-muted)',
                                        '&:hover': {color: 'var(--app-text-primary)'},
                                        px: 1,
                                        py: 0.5,
                                    }}
                                >
                                    View all →
                                </Button>
                            )}
                        </Box>
                        {/* Cards – smaller thumbnails via maxWidth constraint */}
                        <Grid container spacing={2} sx={{maxWidth: '1300px'}}>
                            <ProjectsView projects={sortedProjects.slice(0, 5)} showAsGrids={true}
                                          setSwitchToComputerFormOpen={setSwitchToComputerFormOpen}
                                          isMobile={isMobile} deleteProject={handleDeleteProjectClick}
                                          handleProjectCardClick={handleProjectCardClick}/>
                        </Grid>
                    </Box>
                )}
            </Box>
        )
    }

    useEffect(() => {
        if (currentProjectId === null) {
            return;
        }

        const LoadProjectUrls = async () => {
            try {
                await fetchContext.authAxios.get(`/project/${currentProjectId}`, {
                    headers: {
                        Authorization: `Bearer ${authContext.getToken()}`,
                    }
                });
            } catch (error) {
                console.error("Error getting track urls:", error);
            }
        }

        LoadProjectUrls();
        return () => {
        };
    }, [currentProjectId]);

    const initialOnboardingModalNode = (
        <InitialOnboardingModal
            open={Boolean(initialOnboardingStep) && !isFreePlan}
            isMobile={isMobile}
            isReturningMobileUser={Boolean(isMobile && userBillingState.hasSeenTrialModal)}
            step={initialOnboardingStep}
            roleValue={initialOnboardingRole}
            firstThingValue={initialOnboardingFirstThingToSee}
            demoPlaybackId={initialOnboardingDemoPlaybackId}
            onSelectRole={handleInitialOnboardingRoleSelect}
            onSelectFirstThing={handleInitialOnboardingFirstThingSelect}
            onContinueFromMobileDemo={handleContinueInitialOnboardingMobileDemo}
            onEmailMeLink={handleEmailMeLibrettoLink}
            onLogout={() => authContext.logout?.()}
        />
    );
    const shouldShowMobileOnboardingOnly =
        !isFreePlan &&
        isMobile &&
        (!userBillingState.loaded || !userBillingState.hasCompletedInitialOnboarding || Boolean(initialOnboardingStep));

    if (shouldShowMobileOnboardingOnly) {
        return (
            <Box style={pageStyle}>
                <OfflineBanner message="Cached projects are available. Uploads and studios are unavailable."/>
                <SignInUserIntercomComponent user={authContext.getUser()}/>
                {initialOnboardingModalNode}
            </Box>
        );
    }

    return (
        <Box style={pageStyle}>
            <OfflineBanner message="Cached projects are available. Uploads and studios are unavailable."/>
            <SignInUserIntercomComponent user={authContext.getUser()}/>
            <ConfirmDialogComponent/>
            <WorkspaceSettingsModal
                open={settingsModalOpen}
                onClose={closeSettingsModal}
                defaultTab={settingsActiveTab}
                authContext={authContext}
                checkoutStatus={checkoutStatus}
                isCheckoutProcessing={isCheckoutProcessing}
            />
            {initialOnboardingModalNode}
            <FirstExportActivationModal
                open={trialModalOpen && !isFreePlan && !isLifetimePlanUser}
                showWelcome={!isReopenedActivationModal}
                samples={activationSampleRecordings}
                autoStartAction={activationModalAutoAction}
                onClose={handleCloseTrialModal}
                onTrySample={handleTrySampleFromActivationModal}
                onUseOwnRecording={handleUseOwnRecordingFromActivationModal}
            />
            <Drawer
                anchor="right"
                open={assistantDrawerOpen && !isFreePlan}
                onClose={() => setAssistantDrawerOpen(false)}
                ModalProps={{keepMounted: true}}
                PaperProps={{
                    sx: {
                        width: {xs: "calc(100vw - 24px)", sm: "360px"},
                        maxWidth: "360px",
                        height: "100%",
                        p: 1,
                        backgroundColor: "var(--app-bg-surface)",
                    },
                }}
            >
                <V2AssistantSidebar
                    messages={assistantMessages}
                    onSend={handleSendAssistantMessage}
                    isSending={isAssistantSending}
                    error={assistantActionError || assistantRequestError}
                    onClose={() => setAssistantDrawerOpen(false)}
                    emptyDescription="Ask a question or tell me what files you have and what you want to do with them."
                    placeholder="I want to edit my video recording"
                />
            </Drawer>
            <Box
                className={sidebarClassName}
                sx={{
                    ...sideBarStyle(isMobile),
                    // When collapsed sidebar is hovered, show expand button, hide logo
                    '&.sidebar-collapsed:hover .collapsed-logo': {
                        opacity: 0,
                    },
                    '&.sidebar-collapsed:hover .collapsed-expand-btn': {
                        opacity: 1,
                    },
                }}
            >
                {/* Logo and toggle area - on same horizontal line */}
                <Box sx={{
                    display: "flex",
                    padding: sidebarCollapsed ? "20px 0px" : "20px 12px",
                    alignItems: "center",
                    justifyContent: sidebarCollapsed ? "center" : "space-between",
                    alignSelf: "stretch",
                    marginBottom: "12px",
                    height: "40px", // Fixed height to prevent layout shift
                }}>
                    {sidebarCollapsed ? (
                        // When collapsed: show logo by default, expand button on sidebar hover (CSS-only)
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "36px",
                            height: "36px",
                            position: "relative",
                        }}>
                            <Tooltip title="Libretto" placement="right">
                                <Box
                                    className="collapsed-logo"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        width: "36px",
                                        height: "36px",
                                        opacity: 1,
                                        transition: "opacity 0.15s ease",
                                    }}
                                    onClick={() => navigate("/")}
                                >
                                    <NewLogoIcon/>
                                </Box>
                            </Tooltip>
                            <Tooltip title="Open Sidebar" placement="right">
                                <IconButton
                                    className="collapsed-expand-btn"
                                    onClick={() => setSidebarCollapsed(false)}
                                    sx={{
                                        position: "absolute",
                                        color: "var(--app-text-muted)",
                                        padding: "6px",
                                        width: "36px",
                                        height: "36px",
                                        opacity: 0,
                                        transition: "opacity 0.15s ease",
                                        '&:hover': {backgroundColor: "var(--app-bg-subtle)"},
                                    }}
                                >
                                    <OpenSidebarIcon/>
                                </IconButton>
                            </Tooltip>
                        </Box>
                    ) : (
                        // When expanded: logo on left, collapse button on right
                        <>
                            <Box sx={{display: "flex", cursor: "pointer", alignItems: "center", height: "36px"}}
                                 onClick={() => navigate("/")}>
                                <NewLogoIconWithText/>
                            </Box>
                            <Tooltip title="Close Sidebar" placement="right">
                                <IconButton
                                    onClick={() => setSidebarCollapsed(true)}
                                    sx={{
                                        color: "var(--app-text-muted)",
                                        padding: "6px",
                                        width: "36px",
                                        height: "36px",
                                        '&:hover': {backgroundColor: "var(--app-bg-subtle)"},
                                    }}
                                >
                                    <CloseSidebarIcon/>
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                </Box>

                <WorkspaceSwitcher
                    collapsed={sidebarCollapsed}
                    workspaces={workspaces}
                    currentWorkspaceId={currentWorkspaceId}
                    onSelect={handleWorkspaceSelect}
                />

                <Box style={dividerStyle}>
                    <Box style={actualDividerStyle}/>
                </Box>
                <Box sx={{
                    flexGrow: 1,
                    maxHeight: "calc(100vh - 100px)",
                    overflowY: "auto",
                    alignItems: "center",
                    gap: "4px",
                    width: "100%",
                }}>
                    {sidebarCollapsed ? (
                        <Tooltip title="Home" placement="right">
                            <IconButton
                                onClick={handleHomeSidebarButtonClick}
                                sx={collapsedSidebarNavButtonSx(currentView === ViewState.HOME)}
                            >
                                <HomeOutlinedIcon/>
                            </IconButton>
                        </Tooltip>
                    ) : (
                        <SidebarNavButton label={"Home"} onClick={handleHomeSidebarButtonClick}
                                          selected={currentView === ViewState.HOME}
                                          icon={<HomeOutlinedIcon sx={{color: "var(--app-text-muted)"}}/>}/>
                    )}
                    <Box sx={{marginTop: "8px"}}>
                        {sidebarCollapsed ? (
                            <Tooltip title="Projects" placement="right">
                                <IconButton
                                    onClick={handleProjectsSidebarButtonClick}
                                    sx={collapsedSidebarNavButtonSx(currentView === ViewState.PROJECTS)}
                                >
                                    <FolderOpenOutlinedIcon/>
                                </IconButton>
                            </Tooltip>
                        ) : (
                            <SidebarNavButton label={"Projects"} onClick={handleProjectsSidebarButtonClick}
                                              selected={currentView === ViewState.PROJECTS}
                                              icon={<FolderOpenOutlinedIcon sx={{color: "var(--app-text-muted)"}}/>}/>
                        )}
                    </Box>
                    {/*<Box sx={{marginTop: "8px"}}>*/}
                    {/*    {sidebarCollapsed ? (*/}
                    {/*        <Tooltip title="Quick guided demos" placement="right">*/}
                    {/*            <IconButton*/}
                    {/*                onClick={handleOpenActivationModal}*/}
                    {/*                sx={collapsedSidebarNavButtonSx(trialModalOpen)}*/}
                    {/*            >*/}
                    {/*                {demoIconNode}*/}
                    {/*            </IconButton>*/}
                    {/*        </Tooltip>*/}
                    {/*    ) : (*/}
                    {/*        <SidebarNavButton*/}
                    {/*            label={"Quick guided demos"}*/}
                    {/*            onClick={handleOpenActivationModal}*/}
                    {/*            selected={trialModalOpen}*/}
                    {/*            icon={demoIconNode}*/}
                    {/*        />*/}
                    {/*    )}*/}
                    {/*</Box>*/}
                    {!sidebarCollapsed && currentView === ViewState.SINGLE_PROJECT && currentProjectId &&
                        <SidebarSubdirButton icon={<SubdirectoryArrowRightIcon/>} selected={true}
                                             label={currentProjectTitle} onClick={() => {
                        }}/>}

                    {/* Legacy Projects - only show if user has legacy projects */}
                    {hasLegacyProjects && (
                        <>
                            <Box sx={{
                                height: "1px",
                                backgroundColor: "var(--app-border-subtle)",
                                margin: sidebarCollapsed ? "16px 0" : "16px 0",
                                alignSelf: "stretch",
                                opacity: 0.6,
                            }}/>
                            {sidebarCollapsed ? (
                                <Tooltip title="Legacy Projects" placement="right">
                                    <IconButton
                                        onClick={() => setCurrentView(ViewState.LEGACY_PROJECTS)}
                                        sx={collapsedSidebarNavButtonSx(currentView === ViewState.LEGACY_PROJECTS)}
                                    >
                                        <InventoryOutlinedIcon sx={{fontSize: 22}}/>
                                    </IconButton>
                                </Tooltip>
                            ) : (
                                <SidebarNavButton
                                    label="Legacy Projects"
                                    onClick={() => setCurrentView(ViewState.LEGACY_PROJECTS)}
                                    selected={currentView === ViewState.LEGACY_PROJECTS}
                                    icon={<InventoryOutlinedIcon sx={{color: "var(--app-text-muted)"}}/>}
                                />
                            )}
                        </>
                    )}
                </Box>
                {/*<Box sx={{marginTop: "auto", flexDirection: "column", gap: "10px", width: "100%"}}>*/}
                {/*    {isRestrictedPlan && !sidebarCollapsed && (*/}
                {/*        <Box sx={upgradeBoxStyle} onClick={navigateToUpgrade}>*/}
                {/*            <HiLightningBolt style={lightningIconStyle} />*/}
                {/*            <Box sx={upgradeInfoStyle}>*/}
                {/*                <Box sx={upgradeTextStyle}>Upgrade</Box>*/}
                {/*                <Box sx={upgradeSubtextStyle}>Unlock full editing & exports</Box>*/}
                {/*            </Box>*/}
                {/*        </Box>*/}
                {/*    )}*/}
                {/*    {isRestrictedPlan && sidebarCollapsed && (*/}
                {/*        <Tooltip title="Upgrade - Unlock full editing & exports" placement="right">*/}
                {/*            <Box*/}
                {/*                onClick={navigateToUpgrade}*/}
                {/*                sx={{*/}
                {/*                    width: 44,*/}
                {/*                    height: 44,*/}
                {/*                    marginLeft: "6px",*/}
                {/*                    borderRadius: "50%",*/}
                {/*                    background: "linear-gradient(135deg, #2B6BFD 0%, #111111 90%)",*/}
                {/*                    color: "#fff",*/}
                {/*                    display: "flex",*/}
                {/*                    alignItems: "center",*/}
                {/*                    justifyContent: "center",*/}
                {/*                    cursor: "pointer",*/}
                {/*                    mb: 1,*/}
                {/*                    transition: "background 0.15s ease, transform 0.08s ease",*/}
                {/*                    "&:hover": {*/}
                {/*                        background: "linear-gradient(90deg, #2358d4, #2670d4)",*/}
                {/*                        transform: "translateY(-1px)",*/}
                {/*                    },*/}
                {/*                    boxShadow: "0 6px 16px rgba(0,0,0,0.2)",*/}
                {/*                }}*/}
                {/*            >*/}
                {/*                <HiLightningBolt style={{fontSize: '20px'}}/>*/}
                {/*            </Box>*/}
                {/*        </Tooltip>*/}
                {/*    )}*/}
                {/*</Box>*/}
            </Box>
            <Box sx={mainAreaStyle(isMobile)}>
                <Box sx={mainInnerStyle(isMobile, mainContentMaxWidth)}>
                    {!isMobile && (
                        <Box sx={topRightProfileRowStyle}>
                            <Tooltip title={profileTooltipText || "Account"} placement="left">
                                <Box sx={topProfileButtonStyle} onClick={handleProfileButtonClick}>
                                    {resolvedProfileImage ? (
                                        <Box component="img" src={resolvedProfileImage} alt="Profile"
                                             sx={topProfileImageStyle}/>
                                    ) : (
                                        <Box
                                            sx={topProfileInitialStyle}>{GetInitial(authContext.getUserDisplayName())}</Box>
                                    )}
                                </Box>
                            </Tooltip>
                        </Box>
                    )}
                    {profileAvatarMenuOpen && (
                        <ProfileAvatarMenu
                            profileMenuTop={profileMenuTop}
                            profileMenuRight={profileMenuRight}
                            setProfileAvatarMenuOpen={setProfileAvatarMenuOpen}
                            handleLogoutClick={() => logoutUser()}
                            handleSettingsClick={() => openSettingsModal("profile")}
                            themePreference={themePreference}
                            handleThemePreferenceChange={setThemePreference}
                            showThemeOption={true}
                        />
                    )}
                    {shouldShowTrialBanner && (
                        <Box sx={trialBannerStyle}>
                            <Typography sx={trialBannerTextStyle}>{trialBannerText}</Typography>
                            {isBeforeTrial ? (
                                <Box sx={trialBannerActionsStyle}>
                                    <Button
                                        variant="text"
                                        onClick={handleStartTranscriptActivation}
                                        sx={trialBannerLinkStyle}
                                    >
                                        Export your first composition →
                                    </Button>
                                </Box>
                            ) : (
                                <Box sx={trialBannerActionsStyle}>
                                    <Button
                                        variant="text"
                                        onClick={handleAddPaymentMethodClick}
                                        disabled={isCheckoutStarting}
                                        sx={trialBannerLinkStyle}
                                    >
                                        {isCheckoutStarting ? "Opening..." : "Add payment method"}
                                    </Button>
                                    {/*<IconButton size="small" onClick={handleDismissTrialBanner} sx={{color: "var(--app-text-muted)"}}>*/}
                                    {/*    <Box component="span" sx={{fontSize: "16px", lineHeight: 1}}>×</Box>*/}
                                    {/*</IconButton>*/}
                                </Box>
                            )}
                        </Box>
                    )}
                    {isMobile ? (
                        <>
                            <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                                <Box style={logoBoxStyle} onClick={() => navigate("/")}>
                                    <LogoIcon/>
                                </Box>
                                <Box style={logoBoxStyle}>
                                    <MobileLogoutButton onClick={logoutUser}/>
                                </Box>
                            </Box>

                            <Box sx={{
                                borderRadius: 2,
                                border: "1px solid var(--app-border-subtle)",
                                backgroundColor: "var(--app-bg-surface)",
                                overflow: "hidden"
                            }}>
                                {sortedProjects.map((project) => (
                                    <Box
                                        key={project.projectId}
                                        onClick={() => handleProjectCardClick(project)}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            padding: "14px 16px",
                                            borderBottom: "1px solid var(--app-border-subtle)",
                                            cursor: "pointer",
                                            "&:hover": {background: "var(--app-bg-subtle)"},
                                        }}
                                    >
                                        <Box sx={{minWidth: 0, display: "flex", flexDirection: "column"}}>
                                            <Box sx={{
                                                fontFamily: "Inter",
                                                fontSize: 14,
                                                fontWeight: 500,
                                                color: "var(--app-text-primary)",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap"
                                            }}>
                                                {formatToReadableLargeTitle(project.name)}
                                            </Box>
                                        </Box>
                                        <KeyboardArrowRightIcon sx={{color: "var(--app-text-subtle)"}}/>
                                    </Box>
                                ))}
                            </Box>

                            <Dialog
                                open={switchToComputerFormOpen}
                                onClose={() => setSwitchToComputerFormOpen(false)}
                                PaperProps={{
                                    sx: {
                                        width: '420px',
                                        padding: '20px 24px',
                                        borderRadius: '12px',
                                        boxShadow: '0px 20px 60px rgba(15, 23, 42, 0.08)',
                                    }
                                }}
                            >
                                <DialogContent sx={{padding: 0}}>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mb: 1
                                    }}>
                                        <Typography sx={{
                                            fontFamily: 'Inter',
                                            fontSize: 15,
                                            fontWeight: 500,
                                            color: 'var(--app-text-primary)'
                                        }}>
                                            Please switch to a larger screen
                                        </Typography>
                                        <IconButton size="small" onClick={() => setSwitchToComputerFormOpen(false)}
                                                    sx={{color: 'var(--app-text-subtle)'}}>
                                            <Box component="span" sx={{fontSize: '18px', lineHeight: 1}}>×</Box>
                                        </IconButton>
                                    </Box>
                                    <Typography sx={{
                                        fontFamily: 'Inter',
                                        fontSize: 13,
                                        fontWeight: 400,
                                        color: 'var(--app-text-muted)',
                                        lineHeight: '18px'
                                    }}>
                                        Libretto’s editor works best on screens 1000px or wider.
                                    </Typography>
                                </DialogContent>
                            </Dialog>
                        </>
                    ) : (
                        <>
                            {currentView === ViewState.HOME ? HomeViewAtHome() :
                                currentView === ViewState.PROJECTS ? ProjectsViewAtHome() :
                                    currentView === ViewState.LEGACY_PROJECTS ? <LegacyProjectsView/> : null}
                        </>
                    )}
                </Box>
            </Box>
        </Box>
    )
}

export default AgenticHome;
